import {
    convertImgToBase64URLCheckList,
    paintPhotoCheckList,
    removeElementIndexedDB, saveCheckListDB,
    unixTimeToDate,
    isCanvasBlank
} from "../functions";
import {ModalContainerWarningRemovePhotoCheckList} from "../Modal/ModalContainerWarningRemovePhotoCheckList";
import {ModalContainerCHL} from "../Modal/ModalContainerCHL";
import  {modalContainerWarningCheckList } from "@/Modal/ModalContainerWarningCheckList";
import { loader } from '@/components/Loader.js';

export function getDirection() {
    var PV;
    if(document.getElementById("datePlane").classList.contains('bg-info'))
        PV = "П";
    else if(document.getElementById("datePlane").classList.contains('bg-danger'))
        PV = "В";
    return PV;
}

function clickYes(rowNumber) {
    let yes = document.getElementById('checkboxYes'+rowNumber);
    let audit = JSON.parse(localStorage.getItem("checkList"));
    let flightID = audit.flightID;
    let taskID = audit.taskID;

    if (!yes.disabled) {
        let no = document.getElementById('checkboxNo' + rowNumber);
        no.checked = false;
        yes.checked = true;

        loader.show();
        var PV = getDirection();
        var checkList = {
            "check": yes.checked,
            "idTemplate": rowNumber,
            "comment": null,
            "flightID": flightID,
            "taskID": taskID,
            "PV": PV
        };
        m.request({
            method: 'PUT',
            url: '/api/task/' + m.route.param('taskId') + '/setAuditCheck',
            data: checkList
        }).then(function (response) {
            loader.hide();
            let audit = JSON.parse(localStorage.getItem("checkList"));
            audit.check[Number(checkList.idTemplate)-1].value = checkList.check ? "1" : "0";
            localStorage.setItem("checkList", JSON.stringify(audit));

        }, function () {
            loader.hide();
        });
    } else {
        return 0;
    }
}

function clickNo(rowNumber) {
    let yes = document.getElementById('checkboxYes'+rowNumber);
    let audit = JSON.parse(localStorage.getItem("checkList"));
    let flightID = audit.flightID;
    let taskID = audit.taskID;
    if (!yes.disabled) {
        let no = document.getElementById('checkboxNo' + rowNumber);
        yes.checked = false;
        no.checked = true;

        loader.show();
        var PV = getDirection();
        //checkList = { "check": yes.checked, "idTemplate": rowNumber, "comment": null, "PV": PV };
        var checkList = {
            "check": yes.checked,
            "idTemplate": rowNumber,
            "comment": null,
            "flightID": flightID,
            "taskID": taskID,
            "PV": PV
        };
        m.request({
            method: 'PUT',
            url: '/api/task/' + m.route.param('taskId') + '/setAuditCheck',
            data: checkList
        }).then(function (response) {
            loader.hide();
            let audit = JSON.parse(localStorage.getItem("checkList"));
            audit.check[Number(checkList.idTemplate)-1].value = checkList.check ? "1" : "0";
            localStorage.setItem("checkList", JSON.stringify(audit));
        }, function () {
            loader.hide();
        });
    } else {
        return 0;
    }

}

function checkingFilling() {
    for(let i = 1; i < 10; i++) {
        let yes = document.getElementById('checkboxYes'+i);
        let no = document.getElementById('checkboxNo'+i);
        if(yes.checked == false && no.checked == false) {
            return false;
        }
    }
    return true;
}

export var ArrivalFlightChecklistBlock = {
    controller: function (args) {
        this.data = args.data;
        this.info = args.data;
        this.checkList = args.checkList;
        this.turnaround = args.turnaround;
        this.showBookingBlock = args.showBookingBlock ? args.showBookingBlock : null;

        let info = {};
        info['planDate'] = this.data.planDate;
        info['BORT'] = this.data.BORT;
        info['NR'] = this.data.NR;
        info['PV'] = this.data.PV;
        info['TS_ICAO'] = this.data.TS_ICAO;

        localStorage.setItem("checkList", JSON.stringify(this.checkList));
        localStorage.setItem("turnaround", JSON.stringify(this.turnaround));
        localStorage.setItem("info", JSON.stringify(info));

        if(this.turnaround != null && this.turnaround != "Борт не назначен!") {
            if (this.turnaround['factBeginAudit'] != null) {
                let dt = this.turnaround['factBeginAudit'].split(' ');
                let date = dt[0];
                let time = dt[1];

                let arrDate = date.split('-');
                date = arrDate[2] + "." + arrDate[1] + "." + arrDate[0];

                let arrTime = time.split(":");
                time = arrTime[0] + ":" + arrTime[1];

                this.turnaround['factBeginAudit'] = date + " " + time;
            }

            if (this.turnaround['signDT'] != null) {
                let time = this.turnaround['signDT'].split(' ')[1];
                let arrTime = time.split(":");
                time = arrTime[0] + ":" + arrTime[1];

                this.turnaround['signDT'] = time;
            }
        }

        if(this.checkList.sign)
            paintPhotoCheckList(localStorage.getItem("directionFlight"), this.checkList.sign);
    },
    view: function (ctrl) {
        return m(".container[id='container'][style='padding-top:10px']", [
            ctrl.checkList == 2 || ctrl.checkList == 1 ? [] : [
                ctrl.turnaround != null ? /*ctrl.turnaround['sign'] != false ?*/ m(".row[style='margin: 0 1px;'][id='rowTurnaround']", [
                    m("span.col-12[style='padding:0 10px 0 5px'][id='labelTurnaround']", "Чек-лист вылета:"),
                    m("button.btn.btn-block.block-departure[style='border-radius: 5px'][id='buttonTurnaround']", {
                        onclick: function () {

                            let turnaround = JSON.parse(localStorage.getItem("turnaround"));

                            if(turnaround["factBeginAudit"] == null)
                            {
                                loader.show();
                                /*var PV = getDirection();
                                checkList = {
                                    "flightID": turnaround["flightID"],
                                    "taskID": turnaround["taskID"],
                                    "PV": turnaround["PV"]
                                };*/
                                m.request({
                                    method: 'PUT',
                                    url: '/api/task/logCreateAudit',
                                    data: JSON.stringify(turnaround)
                                }).then(function (response) {
                                    loader.hide();

                                    let info = {};
                                    info['planDate'] = response["planDate"];
                                    info['BORT'] = response["BORT"];
                                    info['NR'] = response["NR"];
                                    info['PV'] = response["PV"];
                                    info['TS_ICAO'] = response["TS_ICAO"];

                                    let audit = localStorage.getItem("checkList");
                                    localStorage.setItem("checkList", JSON.stringify(response));
                                    localStorage.setItem("turnaround", audit/*JSON.stringify(ctrl.checkList)*/);
                                    localStorage.setItem("info", JSON.stringify(info));

                                    printCheckList();
                                    //let audit = JSON.parse(localStorage.getItem("checkList"));
                                    //audit.check[Number(checkList.idTemplate)-1].value = checkList.check ? "1" : "0";
                                    //localStorage.setItem("checkList", JSON.stringify(audit));
                                }, function () {
                                    loader.hide();
                                });
                            }
                            else {
                                let info = {};
                                info['planDate'] = turnaround["planDate"];
                                info['BORT'] = turnaround["BORT"];
                                info['NR'] = turnaround["NR"];
                                info['PV'] = turnaround["PV"];
                                info['TS_ICAO'] = turnaround["TS_ICAO"];

                                let audit = localStorage.getItem("checkList");
                                localStorage.setItem("checkList", localStorage.getItem("turnaround"));
                                localStorage.setItem("turnaround", audit);
                                localStorage.setItem("info", JSON.stringify(info));

                                printCheckList();
                            }
                        }
                    }, ctrl.turnaround.NR + " " + ctrl.turnaround.BORT + "  " + (ctrl.turnaround.factBeginAudit == null ? "-" : ctrl.turnaround.factBeginAudit) +
                        " / " + (ctrl.turnaround.signDT == null ? "без подписи" : ctrl.turnaround.signDT)),
                ]) : []/* : []*/
            ],

            ctrl.checkList == 2 || ctrl.checkList == 1 ? [] :
                [
                    m(".row", [
                        m(".col-xs-12.text-center[style='padding:7px']", [
                            m("strong[style='font-size:16px']", "ЧЕК ЛИСТ ВНЕШНЕГО ОСМОТРА ВС")
                        ])
                    ]),
                    m(".row", [
                        m(".col-xs-12.text-center[style='padding:7px']", [
                            m("strong[style='font-size:14px'][id='stageFlight']", "Конечный рейс")
                        ])
                    ]),
                    m(".row", [
                        m(".col-xs-3[style='padding:0 5px 0 10px']", [
                            m("span", "Дата"),
                            m("p.text-center.bg-info[id='datePlane'][style='padding:10px 2px; font-size: 14px']", ctrl.data.planDate || m.trust("&nbsp;"))
                        ]),
                        m(".col-xs-3[style='padding:0 10px 0 5px']", [
                            m("span", "№ Рейса"),
                            m("p.text-center.bg-info[id='NR'][style='padding:10px 2px; font-size: 14px']", ctrl.data.NR || m.trust("&nbsp;"))
                        ]),
                        m(".col-xs-3[style='padding:0 10px 0 5px']", [
                            m("span", "Рег. № ВС"),
                            m("p.text-center.bg-info[id='BORT'][style='padding:10px 2px; font-size: 14px']", ctrl.data.BORT || m.trust("&nbsp;"))
                        ]),
                        m(".col-xs-3[style='padding:0 10px 0 5px']", [
                            m("span", "Тип ВС"),
                            m("p.text-center.bg-info[id='TS_ICAO'][style='padding:10px 2px; font-size: 14px']", ctrl.data.TS_ICAO || m.trust("&nbsp;"))
                        ])
                    ]),
                    m(".row", [m("br", "")]),
                    m("table.table.table-bordered ", [
                        m("thead", [
                            m("tr", [
                                m("th.col-xs-8[rowspan='2'][style='vertical-align: middle']", [
                                    m(".text-center", "Зоны, элементы конструкции " +
                                        "ВС для осмотра. Соответствие ТУ."),
                                    //m("p.text-center.bg-info", ctrl.data.BORT || m.trust("&nbsp;"))
                                ]),
                                m("th.col-xs-4[colspan='2'][style='vertical-align: middle']", [
                                    m(".text-center", "Прибытие"),
                                    //m("p.text-center.bg-info", ctrl.data.NST || m.trust("&nbsp;"))
                                ])
                            ]),
                            m("tr", [
                                m("th.col-xs-2[style='vertical-align: middle']", [
                                    m(".text-center", "ДА"),
                                    //m("p.text-center.bg-info", ctrl.data.NST || m.trust("&nbsp;"))
                                ]),
                                m("th.col-xs-2[style='vertical-align: middle']", [
                                    m(".text-center", "НЕТ"),
                                    //m("p.text-center.bg-info", ctrl.data.NST || m.trust("&nbsp;"))
                                ])
                            ])
                        ]),
                        m("tbody", [
                            ////////////////////////////////====1====/////////////////////////////////////////////
                            m("tr", [
                                m("td.col-xs-8.unselectable[style='vertical-align: middle'][id='td1']", [
                                    m("button[style='border-radius: 5px'][id='row1']", {
                                        class: "btn btn-block block-arrival",
                                        onclick: function () {
                                            let comment = document.getElementById("comment1");

                                            if(comment.hidden)
                                                comment.hidden = false;
                                            else
                                                comment.hidden = true;
                                        }
                                    }, "Датчики, приемники воздушного давления  ", [(ctrl.checkList.check[0].comment.trim()) ? m("span.glyphicon.glyphicon-star[id='icon1']") : ""] ),
                                    m("div[style='padding:7px 15px'][id='comment1'][hidden]", [
                                        m("b", "Примечание"),
                                        m("div", [
                                            m("textarea.form-control[id='textComment1']", {
                                                disabled: ctrl.checkList.sign ? "disabled" : "",
                                                //readonly: true,
                                                onchange: function () {
                                                    let elemIcon = document.getElementById("icon1");
                                                    if(elemIcon == null && this.value.trim() != "") {
                                                        let row = document.getElementById("row1");
                                                        let element = ("span");
                                                        let icon = document.createElement(element);
                                                        icon.className = "glyphicon glyphicon-star";
                                                        icon.id = "icon1";
                                                        row.appendChild(icon);
                                                    }

                                                    if (elemIcon && this.value.trim() == "") {
                                                        document.getElementById("icon1").remove();
                                                    }

                                                    let audit = JSON.parse(localStorage.getItem("checkList"));
                                                    let flightID = audit.flightID;
                                                    let taskID = audit.taskID;

                                                    loader.show();
                                                    var PV = getDirection();
                                                    var checkList = { "check": null, "flightID": flightID, "taskID": taskID, "idTemplate": 1, "comment": this.value.trim(), "PV": PV };
                                                    m.request({
                                                        method: 'PUT',
                                                        url: '/api/task/' + m.route.param('taskId') + '/setAuditCheck',
                                                        data: checkList
                                                    }).then(function (response) {
                                                        loader.hide();
                                                        document.getElementById("comment1").hidden = true;

                                                        let audit = JSON.parse(localStorage.getItem("checkList"));
                                                        audit.check[Number(checkList.idTemplate)-1].comment = checkList.comment;
                                                        localStorage.setItem("checkList", JSON.stringify(audit));
                                                    }, function () {
                                                        loader.hide();
                                                    });
                                                }
                                            }, ctrl.checkList.check[0].comment.trim())
                                        ]),
                                    ]),
                                ]),
                                m("td.col-xs-2[style='vertical-align: middle; text-align: center;']", {
                                    onclick: function () {
                                        if(clickYes("1") !== 0)
                                            ctrl.checkList.check[0].value = true;
                                    }
                                }, [
                                    m("input.form-check-input [type='checkbox'][id='checkboxYes1']", {
                                        disabled: ctrl.checkList.sign ? "disabled" : "",
                                        checked: ctrl.checkList.check[0].value != null ? ctrl.checkList.check[0].value : false
                                    }),
                                ]),
                                m("td.col-xs-2[style='vertical-align: middle; text-align: center']", {
                                    onclick: function () {
                                        if(clickNo("1") !== 0)
                                            ctrl.checkList.check[0].value = false;
                                    }
                                }, [
                                    m("input.form-check-input [type='checkbox'][id='checkboxNo1']", {
                                        disabled: ctrl.checkList.sign ? "disabled" : "",
                                        checked: ctrl.checkList.check[0].value !== null ? ((ctrl.checkList.check[0].value == 0) ? true : false) : false
                                    }),
                                ])
                            ]),
                            ////////////////////////////////====2====/////////////////////////////////////////////
                            m("tr", [
                                m("td.col-xs-8[style='vertical-align: middle'][id='td2']", [
                                    m("button.btn.btn-block.block-arrival[style='border-radius: 5px'][id='row2']", {
                                        onclick: function () {
                                            let comment = document.getElementById("comment2");
                                            if(comment.hidden)
                                                comment.hidden = false;
                                            else
                                                comment.hidden = true;
                                        }
                                    }, "Двери, дверные проемы, лючки и панели доступа  ", [(ctrl.checkList.check[1].comment.trim()) ? m("span.glyphicon.glyphicon-star[id='icon2']") : ""]),
                                    m("div[style='padding:7px 15px'][id='comment2'][hidden]", [
                                        m("b", "Примечание"),
                                        m("div", [
                                            m("textarea.form-control[id='textComment2']", {
                                                disabled: ctrl.checkList.sign ? "disabled" : "",
                                                onchange: function () {
                                                    let elemIcon = document.getElementById("icon2");
                                                    if(elemIcon == null && this.value.trim() != "") {
                                                        let row = document.getElementById("row2");
                                                        let element = ("span");
                                                        let icon = document.createElement(element);
                                                        icon.className = "glyphicon glyphicon-star";
                                                        icon.id = "icon2";
                                                        row.appendChild(icon);
                                                    }

                                                    if (elemIcon && this.value.trim() == "") {
                                                        document.getElementById("icon2").remove();
                                                    }

                                                    let audit = JSON.parse(localStorage.getItem("checkList"));
                                                    let flightID = audit.flightID;
                                                    let taskID = audit.taskID;

                                                    loader.show();
                                                    var PV = getDirection();
                                                    var checkList = { "check": null, "flightID": flightID, "taskID": taskID, "idTemplate": 2, "comment": this.value.trim(), "PV": PV };
                                                    m.request({
                                                        method: 'PUT',
                                                        url: '/api/task/' + m.route.param('taskId') + '/setAuditCheck',
                                                        data: checkList
                                                    }).then(function (response) {
                                                        loader.hide();
                                                        document.getElementById("comment2").hidden = true;

                                                        let audit = JSON.parse(localStorage.getItem("checkList"));
                                                        audit.check[Number(checkList.idTemplate)-1].comment = checkList.comment;
                                                        localStorage.setItem("checkList", JSON.stringify(audit));
                                                    }, function () {
                                                        loader.hide();
                                                    });
                                                }
                                            }, ctrl.checkList.check[1].comment.trim()),
                                        ]),
                                    ]),
                                    //m("p.text-center.bg-danger", ctrl.data.NST || m.trust("&nbsp;"))
                                ]),
                                m("td.col-xs-2[style='vertical-align: middle; text-align: center']", {
                                    onclick: function () {
                                        if(clickYes("2", ctrl.checkList.flightID, ctrl.checkList.taskID) !== 0)
                                            ctrl.checkList.check[1].value = true;
                                    }
                                }, [
                                    m("input.form-check-input [type='checkbox'][id='checkboxYes2']", {
                                        disabled: ctrl.checkList.sign ? "disabled" : "",
                                        checked: ctrl.checkList.check[1].value != null ? ctrl.checkList.check[1].value : false
                                    }),
                                    //m("p.text-center.bg-danger", ctrl.data.NST || m.trust("&nbsp;"))
                                ]),
                                m("td.col-xs-2[style='vertical-align: middle; text-align: center']", {
                                    onclick: function () {
                                        if(clickNo("2") !== 0)
                                            ctrl.checkList.check[1].value = false;
                                    }
                                }, [
                                    m("input.form-check-input [type='checkbox'][id='checkboxNo2']", {
                                        disabled: ctrl.checkList.sign ? "disabled" : "",
                                        checked: ctrl.checkList.check[1].value !== null ? ((ctrl.checkList.check[1].value == 0) ? true : false) : false
                                    }),
                                    //m("p.text-center.bg-danger", ctrl.data.NST || m.trust("&nbsp;"))
                                ])
                            ]),
                            ////////////////////////////////====3====/////////////////////////////////////////////
                            m("tr", [
                                m("td.col-xs-8[style='vertical-align: middle'][id='td3']", [
                                    m("button.btn.btn-block.block-arrival[style='border-radius: 5px'][id='row3']", {
                                        onclick: function () {
                                            let comment = document.getElementById("comment3");
                                            if(comment.hidden)
                                                comment.hidden = false;
                                            else
                                                comment.hidden = true;
                                        }
                                    }, "Обтекатель радара  ", [(ctrl.checkList.check[2].comment.trim()) ? m("span.glyphicon.glyphicon-star[id='icon3']") : ""]),
                                    m("div[style='padding:7px 15px'][id='comment3'][hidden]", [
                                        m("b", "Примечание"),
                                        m("div", [
                                            m("textarea.form-control[id='textComment3']", {
                                                disabled: ctrl.checkList.sign ? "disabled" : "",
                                                onchange: function () {
                                                    let elemIcon = document.getElementById("icon3");
                                                    if(elemIcon == null && this.value.trim() != "") {
                                                        let row = document.getElementById("row3");
                                                        let element = ("span");
                                                        let icon = document.createElement(element);
                                                        icon.className = "glyphicon glyphicon-star";
                                                        icon.id = "icon3";
                                                        row.appendChild(icon);
                                                    }

                                                    if (elemIcon && this.value.trim() == "") {
                                                        document.getElementById("icon3").remove();
                                                    }

                                                    let audit = JSON.parse(localStorage.getItem("checkList"));
                                                    let flightID = audit.flightID;
                                                    let taskID = audit.taskID;

                                                    loader.show();
                                                    var PV = getDirection();
                                                    var checkList = { "check": null, "flightID": flightID, "taskID": taskID, "idTemplate": 3, "comment": this.value.trim(), "PV": PV };
                                                    m.request({
                                                        method: 'PUT',
                                                        url: '/api/task/' + m.route.param('taskId') + '/setAuditCheck',
                                                        data: checkList
                                                    }).then(function (response) {
                                                        loader.hide();
                                                        document.getElementById("comment3").hidden = true;

                                                        let audit = JSON.parse(localStorage.getItem("checkList"));
                                                        audit.check[Number(checkList.idTemplate)-1].comment = checkList.comment;
                                                        localStorage.setItem("checkList", JSON.stringify(audit));
                                                    }, function () {
                                                        loader.hide();
                                                    });
                                                }
                                            }, ctrl.checkList.check[2].comment.trim()),
                                        ]),
                                    ]),
                                    //m("p.text-center.bg-danger", ctrl.data.NST || m.trust("&nbsp;"))
                                ]),
                                m("td.col-xs-2[style='vertical-align: middle; text-align: center']", {
                                    onclick: function () {
                                        if(clickYes("3", ctrl.checkList.flightID, ctrl.checkList.taskID) !== 0)
                                            ctrl.checkList.check[2].value = true;
                                    }
                                }, [
                                    m("input.form-check-input [type='checkbox'][id='checkboxYes3']", {
                                        disabled: ctrl.checkList.sign ? "disabled" : "",
                                        checked: ctrl.checkList.check[2].value != null ? ctrl.checkList.check[2].value : false
                                    }),
                                    //m("p.text-center.bg-danger", ctrl.data.NST || m.trust("&nbsp;"))
                                ]),
                                m("td.col-xs-2[style='vertical-align: middle; text-align: center']", {
                                    onclick: function () {
                                        if(clickNo("3") !== 0)
                                            ctrl.checkList.check[2].value = false;
                                    }
                                }, [
                                    m("input.form-check-input [type='checkbox'][id='checkboxNo3']", {
                                        disabled: ctrl.checkList.sign ? "disabled" : "",
                                        checked: ctrl.checkList.check[2].value !== null ? ((ctrl.checkList.check[2].value == 0) ? true : false) : false
                                    }),
                                    //m("p.text-center.bg-danger", ctrl.data.NST || m.trust("&nbsp;"))
                                ])
                            ]),
                            ////////////////////////////////====4====/////////////////////////////////////////////
                            m("tr", [
                                m("td.col-xs-8[style='vertical-align: middle'][id='td4']", [
                                    m("button.btn.btn-block.block-arrival[style='border-radius: 5px'][id='row4']", {
                                        onclick: function () {
                                            let comment = document.getElementById("comment4");
                                            if(comment.hidden)
                                                comment.hidden = false;
                                            else
                                                comment.hidden = true;
                                        }
                                    }, "Передняя опора шасси, створки, фары  ", [(ctrl.checkList.check[3].comment.trim()) ? m("span.glyphicon.glyphicon-star[id='icon4']") : ""]),
                                    m("div[style='padding:7px 15px'][id='comment4'][hidden]", [
                                        m("b", "Примечание"),
                                        m("div", [
                                            m("textarea.form-control[id='textComment4']", {
                                                disabled: ctrl.checkList.sign ? "disabled" : "",
                                                onchange: function () {
                                                    let elemIcon = document.getElementById("icon4");
                                                    if(elemIcon == null && this.value.trim() != "") {
                                                        let row = document.getElementById("row4");
                                                        let element = ("span");
                                                        let icon = document.createElement(element);
                                                        icon.className = "glyphicon glyphicon-star";
                                                        icon.id = "icon4";
                                                        row.appendChild(icon);
                                                    }

                                                    if (elemIcon && this.value.trim() == "") {
                                                        document.getElementById("icon4").remove();
                                                    }

                                                    let audit = JSON.parse(localStorage.getItem("checkList"));
                                                    let flightID = audit.flightID;
                                                    let taskID = audit.taskID;

                                                    loader.show();
                                                    var PV = getDirection();
                                                    var checkList = { "check": null, "flightID": flightID, "taskID": taskID, "idTemplate": 4, "comment": this.value.trim(), "PV": PV };
                                                    m.request({
                                                        method: 'PUT',
                                                        url: '/api/task/' + m.route.param('taskId') + '/setAuditCheck',
                                                        data: checkList
                                                    }).then(function (response) {
                                                        loader.hide();
                                                        document.getElementById("comment4").hidden = true;

                                                        let audit = JSON.parse(localStorage.getItem("checkList"));
                                                        audit.check[Number(checkList.idTemplate)-1].comment = checkList.comment;
                                                        localStorage.setItem("checkList", JSON.stringify(audit));
                                                    }, function () {
                                                        loader.hide();
                                                    });
                                                }
                                            }, ctrl.checkList.check[3].comment.trim()),
                                        ]),
                                    ]),
                                    //m("p.text-center.bg-danger", ctrl.data.NST || m.trust("&nbsp;"))
                                ]),
                                m("td.col-xs-2[style='vertical-align: middle; text-align: center']", {
                                    onclick: function () {
                                        if(clickYes("4", ctrl.checkList.flightID, ctrl.checkList.taskID) !== 0)
                                            ctrl.checkList.check[3].value = true;
                                    }
                                }, [
                                    m("input.form-check-input [type='checkbox'][id='checkboxYes4']", {
                                        disabled: ctrl.checkList.sign ? "disabled" : "",
                                        checked: ctrl.checkList.check[3].value != null ? ctrl.checkList.check[3].value : false
                                    }),
                                    //m("p.text-center.bg-danger", ctrl.data.NST || m.trust("&nbsp;"))
                                ]),
                                m("td.col-xs-2[style='vertical-align: middle; text-align: center']", {
                                    onclick: function () {
                                        if(clickNo("4") !== 0)
                                            ctrl.checkList.check[3].value = false;
                                    }
                                }, [
                                    m("input.form-check-input [type='checkbox'][id='checkboxNo4']", {
                                        disabled: ctrl.checkList.sign ? "disabled" : "",
                                        checked: ctrl.checkList.check[3].value !== null ? ((ctrl.checkList.check[3].value == 0) ? true : false) : false
                                    }),
                                    //m("p.text-center.bg-danger", ctrl.data.NST || m.trust("&nbsp;"))
                                ])
                            ]),
                            ////////////////////////////////====5====/////////////////////////////////////////////
                            m("tr", [
                                m("td.col-xs-8[style='vertical-align: middle'][id='td5']", [
                                    m("button.btn.btn-block.block-arrival[style='border-radius: 5px'][id='row5']", {
                                        onclick: function () {
                                            let comment = document.getElementById("comment5");
                                            if(comment.hidden)
                                                comment.hidden = false;
                                            else
                                                comment.hidden = true;
                                        }
                                    }, "Фюзеляж, антенны, сливные насадки, фары, маяки  ", [(ctrl.checkList.check[4].comment.trim()) ? m("span.glyphicon.glyphicon-star[id='icon5']") : ""]),
                                    m("div[style='padding:7px 15px'][id='comment5'][hidden]", [
                                        m("b", "Примечание"),
                                        m("div", [
                                            m("textarea.form-control[id='textComment5']", {
                                                disabled: ctrl.checkList.sign ? "disabled" : "",
                                                onchange: function () {
                                                    let elemIcon = document.getElementById("icon5");
                                                    if(elemIcon == null && this.value.trim() != "") {
                                                        let row = document.getElementById("row5");
                                                        let element = ("span");
                                                        let icon = document.createElement(element);
                                                        icon.className = "glyphicon glyphicon-star";
                                                        icon.id = "icon5";
                                                        row.appendChild(icon);
                                                    }

                                                    if (elemIcon && this.value.trim() == "") {
                                                        document.getElementById("icon5").remove();
                                                    }

                                                    let audit = JSON.parse(localStorage.getItem("checkList"));
                                                    let flightID = audit.flightID;
                                                    let taskID = audit.taskID;

                                                    loader.show();
                                                    var PV = getDirection();
                                                    var checkList = { "check": null, "flightID": flightID, "taskID": taskID, "idTemplate": 5, "comment": this.value.trim(), "PV": PV };
                                                    m.request({
                                                        method: 'PUT',
                                                        url: '/api/task/' + m.route.param('taskId') + '/setAuditCheck',
                                                        data: checkList
                                                    }).then(function (response) {
                                                        loader.hide();
                                                        document.getElementById("comment5").hidden = true;

                                                        let audit = JSON.parse(localStorage.getItem("checkList"));
                                                        audit.check[Number(checkList.idTemplate)-1].comment = checkList.comment;
                                                        localStorage.setItem("checkList", JSON.stringify(audit));
                                                    }, function () {
                                                        loader.hide();
                                                    });
                                                }
                                            }, ctrl.checkList.check[4].comment.trim()),
                                        ]),
                                    ]),
                                    //m("p.text-center.bg-danger", ctrl.data.NST || m.trust("&nbsp;"))
                                ]),
                                m("td.col-xs-2[style='vertical-align: middle; text-align: center']", {
                                    onclick: function () {
                                        if(clickYes("5", ctrl.checkList.flightID, ctrl.checkList.taskID) !== 0)
                                            ctrl.checkList.check[4].value = true;
                                    }
                                }, [
                                    m("input.form-check-input [type='checkbox'][id='checkboxYes5']", {
                                        disabled: ctrl.checkList.sign ? "disabled" : "",
                                        checked: ctrl.checkList.check[4].value != null ? ctrl.checkList.check[4].value : false
                                    }),
                                    //m("p.text-center.bg-danger", ctrl.data.NST || m.trust("&nbsp;"))
                                ]),
                                m("td.col-xs-2[style='vertical-align: middle; text-align: center']", {
                                    onclick: function () {
                                        if(clickNo("5") !== 0)
                                            ctrl.checkList.check[4].value = false;
                                    }
                                }, [
                                    m("input.form-check-input [type='checkbox'][id='checkboxNo5']", {
                                        disabled: ctrl.checkList.sign ? "disabled" : "",
                                        checked: ctrl.checkList.check[4].value !== null ? ((ctrl.checkList.check[4].value == 0) ? true : false) : false
                                    }),
                                    //m("p.text-center.bg-danger", ctrl.data.NST || m.trust("&nbsp;"))
                                ])
                            ]),
                            ////////////////////////////////====6====/////////////////////////////////////////////
                            m("tr", [
                                m("td.col-xs-8[style='vertical-align: middle'][id='td6']", [
                                    m("button.btn.btn-block.block-arrival[style='border-radius: 5px'][id='row6']", {
                                        onclick: function () {
                                            let comment = document.getElementById("comment6");
                                            if(comment.hidden)
                                                comment.hidden = false;
                                            else
                                                comment.hidden = true;
                                        }
                                    }, "Двигатели, воздухозаборники, лопатки вентилятора, створки капотов, лючки  ", [(ctrl.checkList.check[5].comment.trim()) ? m("span.glyphicon.glyphicon-star[id='icon6']") : ""]),
                                    m("div[style='padding:7px 15px'][id='comment6'][hidden]", [
                                        m("b", "Примечание"),
                                        m("div", [
                                            m("textarea.form-control[id='textComment6']", {
                                                disabled: ctrl.checkList.sign ? "disabled" : "",
                                                onchange: function () {
                                                    let elemIcon = document.getElementById("icon6");
                                                    if(elemIcon == null && this.value.trim() != "") {
                                                        let row = document.getElementById("row6");
                                                        let element = ("span");
                                                        let icon = document.createElement(element);
                                                        icon.className = "glyphicon glyphicon-star";
                                                        icon.id = "icon6";
                                                        row.appendChild(icon);
                                                    }

                                                    if (elemIcon && this.value.trim() == "") {
                                                        document.getElementById("icon6").remove();
                                                    }

                                                    let audit = JSON.parse(localStorage.getItem("checkList"));
                                                    let flightID = audit.flightID;
                                                    let taskID = audit.taskID;

                                                    loader.show();
                                                    var PV = getDirection();
                                                    var checkList = { "check": null, "flightID": flightID, "taskID": taskID, "idTemplate": 6, "comment": this.value.trim(), "PV": PV };
                                                    m.request({
                                                        method: 'PUT',
                                                        url: '/api/task/' + m.route.param('taskId') + '/setAuditCheck',
                                                        data: checkList
                                                    }).then(function (response) {
                                                        loader.hide();
                                                        document.getElementById("comment6").hidden = true;

                                                        let audit = JSON.parse(localStorage.getItem("checkList"));
                                                        audit.check[Number(checkList.idTemplate)-1].comment = checkList.comment;
                                                        localStorage.setItem("checkList", JSON.stringify(audit));
                                                    }, function () {
                                                        loader.hide();
                                                    });
                                                }
                                            }, ctrl.checkList.check[5].comment.trim()),
                                        ]),
                                    ]),
                                    //m("p.text-center.bg-danger", ctrl.data.NST || m.trust("&nbsp;"))
                                ]),
                                m("td.col-xs-2[style='vertical-align: middle; text-align: center']", {
                                    onclick: function () {
                                        if(clickYes("6", ctrl.checkList.flightID, ctrl.checkList.taskID) !== 0)
                                            ctrl.checkList.check[5].value = true;
                                    }
                                }, [
                                    m("input.form-check-input [type='checkbox'][id='checkboxYes6']", {
                                        disabled: ctrl.checkList.sign ? "disabled" : "",
                                        checked: ctrl.checkList.check[5].value != null ? ctrl.checkList.check[5].value : false
                                    }),
                                    //m("p.text-center.bg-danger", ctrl.data.NST || m.trust("&nbsp;"))
                                ]),
                                m("td.col-xs-2[style='vertical-align: middle; text-align: center']", {
                                    onclick: function () {
                                        if(clickNo("6") !== 0)
                                            ctrl.checkList.check[5].value = false;
                                    }
                                }, [
                                    m("input.form-check-input [type='checkbox'][id='checkboxNo6']", {
                                        disabled: ctrl.checkList.sign ? "disabled" : "",
                                        checked: ctrl.checkList.check[5].value !== null ? ((ctrl.checkList.check[5].value == 0) ? true : false) : false
                                    }),
                                    //m("p.text-center.bg-danger", ctrl.data.NST || m.trust("&nbsp;"))
                                ])
                            ]),
                            ////////////////////////////////====7====/////////////////////////////////////////////
                            m("tr", [
                                m("td.col-xs-8[style='vertical-align: middle'][id='td7']", [
                                    m("button.btn.btn-block.block-arrival[style='border-radius: 5px'][id='row7']", {
                                            onclick: function () {
                                                let comment = document.getElementById("comment7");
                                                if(comment.hidden)
                                                    comment.hidden = false;
                                                else
                                                    comment.hidden = true;
                                            }
                                        }, "Крыло, предкрылки, закрылки, элероны, обтекатели механизации крыла, аэронавигационные и проблесковые огни,  статические разрядники  ",
                                        [(ctrl.checkList.check[6].comment.trim()) ? m("span.glyphicon.glyphicon-star[id='icon7']") : ""]),
                                    m("div[style='padding:7px 15px'][id='comment7'][hidden]", [
                                        m("b", "Примечание"),
                                        m("div", [
                                            m("textarea.form-control[id='textComment7']", {
                                                disabled: ctrl.checkList.sign ? "disabled" : "",
                                                onchange: function () {
                                                    let elemIcon = document.getElementById("icon7");
                                                    if(elemIcon == null && this.value.trim() != "") {
                                                        let row = document.getElementById("row7");
                                                        let element = ("span");
                                                        let icon = document.createElement(element);
                                                        icon.className = "glyphicon glyphicon-star";
                                                        icon.id = "icon7";
                                                        row.appendChild(icon);
                                                    }

                                                    if (elemIcon && this.value.trim() == "") {
                                                        document.getElementById("icon7").remove();
                                                    }

                                                    let audit = JSON.parse(localStorage.getItem("checkList"));
                                                    let flightID = audit.flightID;
                                                    let taskID = audit.taskID;

                                                    loader.show();
                                                    var PV = getDirection();
                                                    var checkList = { "check": null, "flightID": flightID, "taskID": taskID, "idTemplate": 7, "comment": this.value.trim(), "PV": PV };
                                                    m.request({
                                                        method: 'PUT',
                                                        url: '/api/task/' + m.route.param('taskId') + '/setAuditCheck',
                                                        data: checkList
                                                    }).then(function (response) {
                                                        loader.hide();
                                                        document.getElementById("comment7").hidden = true;

                                                        let audit = JSON.parse(localStorage.getItem("checkList"));
                                                        audit.check[Number(checkList.idTemplate)-1].comment = checkList.comment;
                                                        localStorage.setItem("checkList", JSON.stringify(audit));
                                                    }, function () {
                                                        loader.hide();
                                                    });
                                                }
                                            }, ctrl.checkList.check[6].comment.trim()),
                                        ]),
                                    ]),
                                    //m("p.text-center.bg-danger", ctrl.data.NST || m.trust("&nbsp;"))
                                ]),
                                m("td.col-xs-2[style='vertical-align: middle; text-align: center']", {
                                    onclick: function () {
                                        if(clickYes("7", ctrl.checkList.flightID, ctrl.checkList.taskID) !== 0)
                                            ctrl.checkList.check[6].value = true;
                                    }
                                }, [
                                    m("input.form-check-input [type='checkbox'][id='checkboxYes7']", {
                                        disabled: ctrl.checkList.sign ? "disabled" : "",
                                        checked: ctrl.checkList.check[6].value != null ? ctrl.checkList.check[6].value : false
                                    }),
                                    //m("p.text-center.bg-danger", ctrl.data.NST || m.trust("&nbsp;"))
                                ]),
                                m("td.col-xs-2[style='vertical-align: middle; text-align: center']", {
                                    onclick: function () {
                                        if(clickNo("7") !== 0)
                                            ctrl.checkList.check[6].value = false;
                                    }
                                }, [
                                    m("input.form-check-input [type='checkbox'][id='checkboxNo7']", {
                                        disabled: ctrl.checkList.sign ? "disabled" : "",
                                        checked: ctrl.checkList.check[6].value !== null ? ((ctrl.checkList.check[6].value == 0) ? true : false) : false
                                    }),
                                    //m("p.text-center.bg-danger", ctrl.data.NST || m.trust("&nbsp;"))
                                ])
                            ]),
                            ////////////////////////////////====8====/////////////////////////////////////////////
                            m("tr", [
                                m("td.col-xs-8[style='vertical-align: middle'][id='td8']", [
                                    m("button.btn.btn-block.block-arrival[style='border-radius: 5px'][id='row8']", {
                                        onclick: function () {
                                            let comment = document.getElementById("comment8");
                                            if(comment.hidden)
                                                comment.hidden = false;
                                            else
                                                comment.hidden = true;
                                        }
                                    }, "Основные опоры шасси, шины, стойки, створки  ", [(ctrl.checkList.check[7].comment.trim()) ? m("span.glyphicon.glyphicon-star[id='icon8']") : ""]),
                                    m("div[style='padding:7px 15px'][id='comment8'][hidden]", [
                                        m("b", "Примечание"),
                                        m("div", [
                                            m("textarea.form-control[id='textComment8']", {
                                                disabled: ctrl.checkList.sign ? "disabled" : "",
                                                onchange: function () {
                                                    let elemIcon = document.getElementById("icon8");
                                                    if(elemIcon == null && this.value.trim() != "") {
                                                        let row = document.getElementById("row8");
                                                        let element = ("span");
                                                        let icon = document.createElement(element);
                                                        icon.className = "glyphicon glyphicon-star";
                                                        icon.id = "icon8";
                                                        row.appendChild(icon);
                                                    }

                                                    if (elemIcon && this.value.trim() == "") {
                                                        document.getElementById("icon8").remove();
                                                    }

                                                    let audit = JSON.parse(localStorage.getItem("checkList"));
                                                    let flightID = audit.flightID;
                                                    let taskID = audit.taskID;

                                                    loader.show();
                                                    var PV = getDirection();
                                                    var checkList = { "check": null, "flightID": flightID, "taskID": taskID, "idTemplate": 8, "comment": this.value.trim(), "PV": PV };
                                                    m.request({
                                                        method: 'PUT',
                                                        url: '/api/task/' + m.route.param('taskId') + '/setAuditCheck',
                                                        data: checkList
                                                    }).then(function (response) {
                                                        loader.hide();
                                                        document.getElementById("comment8").hidden = true;

                                                        let audit = JSON.parse(localStorage.getItem("checkList"));
                                                        audit.check[Number(checkList.idTemplate)-1].comment = checkList.comment;
                                                        localStorage.setItem("checkList", JSON.stringify(audit));
                                                    }, function () {
                                                        loader.hide();
                                                    });
                                                }
                                            }, ctrl.checkList.check[7].comment.trim()),
                                        ]),
                                    ]),
                                    //m("p.text-center.bg-danger", ctrl.data.NST || m.trust("&nbsp;"))
                                ]),
                                m("td.col-xs-2[style='vertical-align: middle; text-align: center']", {
                                    onclick: function () {
                                        if(clickYes("8", ctrl.checkList.flightID, ctrl.checkList.taskID) !== 0)
                                            ctrl.checkList.check[7].value = true;
                                    }
                                }, [
                                    m("input.form-check-input [type='checkbox'][id='checkboxYes8']", {
                                        disabled: ctrl.checkList.sign ? "disabled" : "",
                                        checked: ctrl.checkList.check[7].value != null ? ctrl.checkList.check[7].value : false
                                    }),
                                    //m("p.text-center.bg-danger", ctrl.data.NST || m.trust("&nbsp;"))
                                ]),
                                m("td.col-xs-2[style='vertical-align: middle; text-align: center']", {
                                    onclick: function () {
                                        if(clickNo("8") !== 0)
                                            ctrl.checkList.check[7].value = false;
                                    }
                                }, [
                                    m("input.form-check-input [type='checkbox'][id='checkboxNo8']", {
                                        disabled: ctrl.checkList.sign ? "disabled" : "",
                                        checked: ctrl.checkList.check[7].value !== null ? ((ctrl.checkList.check[7].value == 0) ? true : false) : false
                                    }),
                                    //m("p.text-center.bg-danger", ctrl.data.NST || m.trust("&nbsp;"))
                                ])
                            ]),
                            ////////////////////////////////====9====/////////////////////////////////////////////
                            m("tr", [
                                m("td.col-xs-8[style='vertical-align: middle'][id='td9']", [
                                    m("button.btn.btn-block.block-arrival[style='border-radius: 5px'][id='row9']", {
                                            onclick: function () {
                                                let comment = document.getElementById("comment9");
                                                if(comment.hidden)
                                                    comment.hidden = false;
                                                else
                                                    comment.hidden = true;
                                            }
                                        }, "Хвостовое оперение, вертикальный стабилизатор и руль направления, горизонтальный стабилизатор и руль высоты, хвостовая опора, воздухозаборник ВСУ и сопло, статические разрядники, проблесковые огни  ",
                                        [(ctrl.checkList.check[8].comment.trim()) ? m("span.glyphicon.glyphicon-star[id='icon9']") : ""]),
                                    m("div[style='padding:7px 15px'][id='comment9'][hidden]", [
                                        m("b", "Примечание"),
                                        m("div", [
                                            m("textarea.form-control[id='textComment9']", {
                                                disabled: ctrl.checkList.sign ? "disabled" : "",
                                                onchange: function () {
                                                    let elemIcon = document.getElementById("icon9");
                                                    if(elemIcon == null && this.value.trim() != "") {
                                                        let row = document.getElementById("row9");
                                                        let element = ("span");
                                                        let icon = document.createElement(element);
                                                        icon.className = "glyphicon glyphicon-star";
                                                        icon.id = "icon9";
                                                        row.appendChild(icon);
                                                    }

                                                    if (elemIcon && this.value.trim() == "") {
                                                        document.getElementById("icon9").remove();
                                                    }

                                                    let audit = JSON.parse(localStorage.getItem("checkList"));
                                                    let flightID = audit.flightID;
                                                    let taskID = audit.taskID;

                                                    loader.show();
                                                    var PV = getDirection();
                                                    var checkList = { "check": null, "flightID": flightID, "taskID": taskID, "idTemplate": 9, "comment": this.value.trim(), "PV": PV };
                                                    m.request({
                                                        method: 'PUT',
                                                        url: '/api/task/' + m.route.param('taskId') + '/setAuditCheck',
                                                        data: checkList
                                                    }).then(function (response) {
                                                        loader.hide();
                                                        document.getElementById("comment9").hidden = true;

                                                        let audit = JSON.parse(localStorage.getItem("checkList"));
                                                        audit.check[Number(checkList.idTemplate)-1].comment = checkList.comment;
                                                        localStorage.setItem("checkList", JSON.stringify(audit));
                                                    }, function () {
                                                        loader.hide();
                                                    });
                                                }
                                            }, ctrl.checkList.check[8].comment.trim()),
                                        ]),
                                    ]),
                                    //m("p.text-center.bg-danger", ctrl.data.NST || m.trust("&nbsp;"))
                                ]),
                                m("td.col-xs-2[style='vertical-align: middle; text-align: center']", {
                                    onclick: function () {
                                        if(clickYes("9", ctrl.checkList.flightID, ctrl.checkList.taskID) !== 0)
                                            ctrl.checkList.check[8].value = true;
                                    }
                                }, [
                                    m("input.form-check-input [type='checkbox'][id='checkboxYes9']", {
                                        disabled: ctrl.checkList.sign ? "disabled" : "",
                                        checked: ctrl.checkList.check[8].value != null ? ctrl.checkList.check[8].value : false
                                    }),
                                    //m("p.text-center.bg-danger", ctrl.data.NST || m.trust("&nbsp;"))
                                ]),
                                m("td.col-xs-2[style='vertical-align: middle; text-align: center']", {
                                    onclick: function () {
                                        if(clickNo("9") !== 0)
                                            ctrl.checkList.check[8].value = false;
                                    }
                                }, [
                                    m("input.form-check-input [type='checkbox'][id='checkboxNo9']", {
                                        disabled: ctrl.checkList.sign ? "disabled" : "",
                                        checked: ctrl.checkList.check[8].value !== null ? ((ctrl.checkList.check[8].value == 0) ? true : false) : false
                                    }),
                                    //m("p.text-center.bg-danger", ctrl.data.NST || m.trust("&nbsp;"))
                                ])
                            ]),

                        ])
                    ]),
                    m("table.table.table", [
                        m("tr", [
                            m("td.col-xs-8[colspan='8'][style='text-align: right']", ["Очистить чек лист"]),
                            m("td.col-xs-4[colspan='4'][style='text-align: right; padding:2px 7px;'][id='tdResetAll']", [
                                m("button.btn.btn-info.btn-lg[style='width:100%'][id='resetAll']", {
                                    disabled: ctrl.checkList.sign ? "disabled" : "",
                                    onclick: function () {
                                        for(let i = 1; i <= 9; i++) {
                                            let numb  = i.toString();
                                            let yes = document.getElementById('checkboxYes'+numb);
                                            let no = document.getElementById('checkboxNo'+numb);
                                            let text = document.getElementById("textComment"+numb);
                                            let icon = document.getElementById("icon"+numb);
                                            let comment = document.getElementById("comment"+numb);
                                            //let saveButton = document.getElementById("saveButton"+numb);
                                            comment.hidden = true;
                                            yes.checked = false;
                                            no.checked = false;
                                            //text.readOnly = false;
                                            //saveButton.disabled = false;
                                            text.value = "";
                                            if(icon)
                                                icon.remove();
                                        }
                                        let commonComment = document.getElementById("commentCheckList");
                                        commonComment.value = "";
                                        loader.show();
                                        var PV = getDirection();
                                        var checklist = { "flightID": ctrl.checkList.flightID, "taskID": ctrl.checkList.taskID, "PV": PV };
                                        m.request({
                                            method: 'PUT',
                                            url: '/api/task/' + m.route.param('taskId') + '/resetAuditCheck',
                                            data: checklist
                                        }).then(function (response) {
                                            loader.hide();
                                            let audit = localStorage.getItem("checkList");
                                            audit = JSON.parse(audit);
                                            for(let i = 0; i < audit.check.length; i++) {
                                                audit.check[i].value = null;
                                                audit.check[i].comment = "";
                                            }
                                            audit.comment = "";
                                            localStorage.setItem("checkList", JSON.stringify(audit));

                                        }, function () {
                                            loader.hide();
                                        });

                                    }
                                },"Сбросить всё")
                            ]),
                        ]),
                        m("tr", [
                            m("td.col-xs-8[colspan='8'][style='text-align: right']", ["Сделать фото"]),
                            m("td.col-xs-4[colspan='4'][style='text-align: right; padding:2px 7px;'][id='tdButtonCamera']", [
                                m("button.btn.btn-info.btn-lg[style='width:100%'][id='buttonCamera']", {
                                    disabled: ctrl.checkList.sign ? "disabled" : "",
                                    onclick: function () {
                                        document.getElementById("cameraFileInput").addEventListener("change", function () {
                                            var name = unixTimeToDate(this.files[0].lastModified);
                                            var dateTime = new Date();
                                            var size = this.files[0].size / 1000000;
                                            var photoUrl = window.URL.createObjectURL(this.files[0]);

                                            convertImgToBase64URLCheckList(photoUrl, function(base64Img){
                                                var base64Photo = base64Img;// Base64DataURL
                                                //let unsavedPhoto = localStorage.getItem("unsavedPhotoCheckList");
                                                let checkList = localStorage.getItem("checkList");
                                                checkList = JSON.parse(checkList);
                                                //if(checklist.photo.length) {
                                                for (let i = 0; i < checkList.photo.length; i++) {
                                                    if(checkList.photo[i].name == name) {
                                                        return;
                                                    }
                                                }
                                                //}
                                                /*if (unsavedPhoto) {
                                                    unsavedPhoto = JSON.parse(unsavedPhoto);
                                                    for (let i = 0; i < unsavedPhoto.length; i++) {
                                                        if(unsavedPhoto[i].name == name) {
                                                            return;
                                                        }
                                                    }
                                                }
                                                else
                                                    unsavedPhoto = [];
                                                 */

                                                //unsavedPhoto.push({ "name": name, "dk": dateTime, "comment": '', "blobUrl": photoUrl, "base64Img": base64Photo });
                                                checkList.photo.push({ "name": name, "dk": dateTime, "comment": '', "blobUrl": photoUrl, "base64Img": base64Photo });

                                                //let value = JSON.stringify(unsavedPhoto);
                                                let value = JSON.stringify(checkList);

                                                //localStorage.setItem("unsavedPhotoCheckList", value);
                                                localStorage.setItem("checkList", value);
                                                paintPhotoCheckList("arrive");
                                            });
                                        });
                                        const input = document.getElementById('cameraFileInput');
                                        input.focus();
                                        input.click();
                                    },
                                }, "Фото"),
                            ]),
                            m("input[id='cameraFileInput'][type='file'][accept='image/*'][capture='environment']")
                        ]),
                        m("tr", [
                            m("td[colspan='12']",[
                                m("div[id='pictureConteiner'][style='width: 100%; height: auto; margin-bottom: 8px;']", [
                                    ctrl.checkList.photo.map(function (elem) {
                                        return m("div", {
                                            id: elem.name,
                                            style: 'display: flex; flex-direction: column; align-items: center; margin-top: 7px; outline: 1px solid #000;'
                                        }, [
                                            m("div", {
                                                className: "row bg-info",
                                                style: "padding:6px;padding-right: 11px;z-index:1; width: 100%; min-height: 32px;"
                                            }, [
                                                ctrl.checkList.sign ? [] : m("span", {
                                                    className: "pull-right classReadOnly",
                                                    style: "cursor: pointer;",
                                                    innerHTML: "<i class='glyphicon glyphicon-remove'>&nbsp;Удалить",
                                                    onclick: function () {
                                                        ModalContainerWarningRemovePhotoCheckList.open("Вы действительно хотите удалить фото?", false, elem.name, false);
                                                    }
                                                })
                                            ]),
                                            m("img", {
                                                src: elem.base64Img, //elem.blobUrl,
                                                name: elem.name,
                                                className: "col-xs-12 col-sm-6 col-md-4 col-xl img-thumbnail",
                                                onerror: function () {
                                                    removeElementIndexedDB(elem.name);
                                                }
                                            })
                                        ])
                                    }),
                                ]),
                                ModalContainerWarningRemovePhotoCheckList.init()
                            ]),
                        ]),
                        m("tr", [
                            m("td.col-xs-4[colspan='4'][style='text-align: right']", ["Примечание"]),
                            m("td.col-xs-8[colspan='8'][style='text-align: right; padding:2px 7px;']", [
                                m("textarea.form-control[rows='3'][maxlength='600'][id='commentCheckList']", {
                                    disabled: ctrl.checkList.sign ? "disabled" : "",
                                    /*onblur: function () {
                                        loader.show();
                                        checkList = { "comment": this.value.trim() };
                                        m.request({
                                            method: 'PUT',
                                            url: '/api/task/' + m.route.param('taskId') + '/setAuditComment',
                                            data: checkList
                                        }).then(function (response) {
                                            loader.hide();
                                        }, function () {
                                            loader.hide();
                                        });
                                    }*/
                                }, ctrl.checkList.comment)
                            ]),
                        ]),
                        m("tr", [
                            m("td.col-xs-8[colspan='8'][style='text-align: right']", ["Осмотр ВС согласно установленного маршрута выполнен"]),
                            m("td.col-xs-4[colspan='4'][style='text-align: right; padding:2px 7px;'][id='tdButtonSign']", [
                                m("button.btn.btn-info.btn-lg[style='width:100%'][id='signAudit']", {
                                    disabled: ctrl.checkList.sign ? "disabled" : "",
                                    //class: showSignatureButton ? '' : 'hidden',
                                    onclick: function () {
                                        let check = checkingFilling();
                                        if(check) {
                                            ModalContainerCHL.open("Подпись чек-листа");
                                            document.getElementById("yesBtnModalSignCheckList").addEventListener("click", function () {
                                                var canvas = document.getElementById("canvasSignCheckList");
                                                if(isCanvasBlank(canvas) == false)
                                                    saveCheckListDB();

                                                ModalContainerCHL.close();
                                            });
                                        }
                                        else {
                                            modalContainerWarningCheckList.open("Чек-лист не заполнен");
                                            //alert("Чек-лист не заполнен");
                                        }
                                    }
                                }, "Подписать")
                            ]),
                            ModalContainerCHL.init()
                        ])
                    ]),
                ]
        ])
    }
};

function getComment(ctrl) {
    document.getElementById("container").remove();
    var container = document.getElementsByClassName("app");

    m.mount(container, m.component(DepartureFlightChecklistBlock, {
        data: ctrl.data,
        checkList: ctrl.checkList,
        turnaround: ctrl.turnaround
    }));
}

function printCheckList(readOnly = false) {

    var rowTurnaround = document.getElementById("rowTurnaround");
    var buttonTurnaround = document.getElementById("buttonTurnaround");
    var datePlane = document.getElementById("datePlane");
    var NR = document.getElementById("NR");
    var BORT = document.getElementById("BORT");
    var TS_ICAO = document.getElementById("TS_ICAO");

    let data = [];
    data["checkList"] = JSON.parse(localStorage.getItem("checkList"));
    data["turnaround"] = JSON.parse(localStorage.getItem("turnaround"));
    data["info"] = JSON.parse(localStorage.getItem("info"));

    if(!readOnly)
        readOnly = data.checkList.readOnly;

    if(data.turnaround.factBeginAudit != null) {
        let dt = data.turnaround.factBeginAudit.split(' ');
        let date = dt[0];
        let time = dt[1];

        let arrDate = date.split('-');
        date = arrDate[2] + "." + arrDate[1] + "." + arrDate[0];

        let arrTime = time.split(":");
        time = arrTime[0] + ":" + arrTime[1];

        data.turnaround.factBeginAudit = date + " " + time;
    }

    if(data.turnaround.signDT != null) {
        let time = data.turnaround.signDT.split(' ')[1];
        let arrTime = time.split(":");
        time = arrTime[0] + ":" + arrTime[1];

        data.turnaround.signDT =  time;
    }

    datePlane.innerText = data.info.planDate;
    NR.innerText = data.info.NR;
    if(data.info.BORT != "")
        BORT.innerText = data.info.BORT;
    TS_ICAO.innerText = data.info.TS_ICAO;

    if(data.info.PV == 'П') {
        datePlane.classList.remove('bg-danger');
        NR.classList.remove('bg-danger');
        BORT.classList.remove('bg-danger');
        TS_ICAO.classList.remove('bg-danger');

        datePlane.classList.add('bg-info');
        NR.classList.add('bg-info');
        BORT.classList.add('bg-info');
        TS_ICAO.classList.add('bg-info');

        document.getElementById("stageFlight").textContent = "Конечный рейс";
        localStorage.setItem("directionFlight", "arrive");

        for(let i=1; i<=9; i++) {
            let numb  = i.toString();
            let row = document.getElementById('row'+numb);
            let yes = document.getElementById('checkboxYes'+numb);
            let no = document.getElementById('checkboxNo'+numb);
            let text = document.getElementById("textComment"+numb);
            var icon = document.getElementById("icon"+numb);
            let commentAudit = document.getElementById("textComment"+numb);

            let textRow = row.textContent;
            row.remove();

            document.getElementById("labelTurnaround").textContent = "Чек-лист вылета";
            row = document.createElement("button");
            row.style = "border-radius: 5px";
            row.className = "btn btn-block block-departure";
            row.textContent = textRow;
            row.id = "row"+numb;
            row.onclick = function () {
                let comment = document.getElementById("comment"+numb);

                if(comment.hidden)
                    comment.hidden = false;
                else
                    comment.hidden = true;
            };
            let td = document.getElementById("td"+numb);
            td.insertBefore(row, td.firstChild);
            // td.appendChild(row);


            if(data.checkList.check[i-1].comment.trim() != "") {

                if (icon != null && data.checkList.check[i - 1].comment.trim() == "") {
                    icon.classList.remove('glyphicon');
                    icon.classList.remove('glyphicon-star');
                } else {
                    let element = ("span");
                    icon = document.createElement(element);
                    icon.className = "glyphicon glyphicon-star";
                    icon.id = "icon" + numb;
                    row.appendChild(icon);
                }
            }
            commentAudit.disabled = data.checkList.sign || readOnly ? "disabled" : "";
            commentAudit.value = data.checkList.check[i-1].comment.trim();


            yes.disabled = data.checkList.sign || readOnly ? "disabled" : "";
            yes.checked = data.checkList.check[i-1].value !== null ? (data.checkList.check[i-1].value == "0" ? false : true) : false;
            //yes.onclick = function () { clickYes((i).toString(), data.checkList.flightID, data.checkList.taskID) };


            no.disabled = data.checkList.sign || readOnly ? "disabled" : "";
            no.checked = data.checkList.check[i-1].value !== null ? ((data.checkList.check[i-1].value == "0") ? true : false) : false;

            row.classList.remove('block-arrival');
            row.classList.add('block-arrival');
        }

        buttonTurnaround.remove();
        let element = ("button");
        buttonTurnaround = document.createElement(element);
        buttonTurnaround.className = "btn btn-block block-departure";
        buttonTurnaround.id = "buttonTurnaround";
        buttonTurnaround.name = data.turnaround.flightId;
        buttonTurnaround.textContent = data.turnaround.NR + " " + data.turnaround.BORT + "  " +
            (data.turnaround.factBeginAudit == null ? "-" : data.turnaround.factBeginAudit) + " / " +
            (data.turnaround.signDT == null ? "без подписи" : data.turnaround.signDT);
        buttonTurnaround.onclick = function () {

            let turnaround = JSON.parse(localStorage.getItem("turnaround"));

            if(turnaround["factBeginAudit"] == null)
            {
                loader.show();
                /*var PV = getDirection();
                checkList = {
                    "flightID": turnaround["flightID"],
                    "taskID": turnaround["taskID"],
                    "PV": turnaround["PV"]
                };*/
                m.request({
                    method: 'PUT',
                    url: '/api/task/logCreateAudit',
                    data: JSON.stringify(turnaround)
                }).then(function (response) {
                    loader.hide();

                    let info = {};
                    info['planDate'] = response["planDate"];
                    info['BORT'] = response["BORT"];
                    info['NR'] = response["NR"];
                    info['PV'] = response["PV"];
                    info['TS_ICAO'] = response["TS_ICAO"];

                    let audit = localStorage.getItem("checkList");
                    localStorage.setItem("checkList", JSON.stringify(response));
                    localStorage.setItem("turnaround", audit/*JSON.stringify(ctrl.checkList)*/);
                    localStorage.setItem("info", JSON.stringify(info));

                    printCheckList();
                    //let audit = JSON.parse(localStorage.getItem("checkList"));
                    //audit.check[Number(checkList.idTemplate)-1].value = checkList.check ? "1" : "0";
                    //localStorage.setItem("checkList", JSON.stringify(audit));
                }, function () {
                    loader.hide();
                });
            }
            else {
                let info = {};
                info['planDate'] = turnaround["planDate"];
                info['BORT'] = turnaround["BORT"];
                info['NR'] = turnaround["NR"];
                info['PV'] = turnaround["PV"];
                info['TS_ICAO'] = turnaround["TS_ICAO"];

                let audit = localStorage.getItem("checkList");
                localStorage.setItem("checkList", localStorage.getItem("turnaround")/*JSON.stringify(ctrl.turnaround)*/);
                localStorage.setItem("turnaround", audit/*JSON.stringify(ctrl.checkList)*/);
                localStorage.setItem("info", JSON.stringify(info));

                printCheckList();
            }

        };

        rowTurnaround.appendChild(buttonTurnaround);

    }
    else {  //data.info.PV == 'В'
        datePlane.classList.remove('bg-info');
        NR.classList.remove('bg-info');
        BORT.classList.remove('bg-info');
        TS_ICAO.classList.remove('bg-info');

        datePlane.classList.add('bg-danger');
        NR.classList.add('bg-danger');
        BORT.classList.add('bg-danger');
        TS_ICAO.classList.add('bg-danger');

        document.getElementById("stageFlight").textContent = "Начальный рейс";
        localStorage.setItem("directionFlight", "departure");

        for(let i=1; i<=9; i++) {
            let numb  = i.toString();
            let row = document.getElementById('row'+numb);
            let yes = document.getElementById('checkboxYes'+numb);
            let no = document.getElementById('checkboxNo'+numb);
            let text = document.getElementById("textComment"+numb);
            var icon = document.getElementById("icon"+numb);
            let commentAudit = document.getElementById("textComment"+numb);

            let textRow = row.textContent;
            row.remove();

            document.getElementById("labelTurnaround").textContent = "Чек-лист прилета";
            row = document.createElement("button");
            row.style = "border-radius: 5px";
            row.className = "btn btn-block block-arrival"; //departure
            row.textContent = textRow;
            row.id = "row"+numb;
            row.onclick = function () {
                let comment = document.getElementById("comment"+numb);

                if(comment.hidden)
                    comment.hidden = false;
                else
                    comment.hidden = true;
            };
            let td = document.getElementById("td"+numb);
            td.insertBefore(row, td.firstChild);
            // td.appendChild(row);


            if(data.checkList.check[i-1].comment.trim() != "") {

                if (icon != null && data.checkList.check[i - 1].comment.trim() == "") {
                    icon.classList.remove('glyphicon');
                    icon.classList.remove('glyphicon-star');
                } else {
                    let element = ("span");
                    icon = document.createElement(element);
                    icon.className = "glyphicon glyphicon-star";
                    icon.id = "icon" + numb;
                    row.appendChild(icon);
                }
            }
            commentAudit.disabled = data.checkList.sign || readOnly ? "disabled" : "";
            commentAudit.value = data.checkList.check[i-1].comment.trim();


            yes.disabled = data.checkList.sign || readOnly ? "disabled" : "";
            yes.checked = data.checkList.check[i-1].value !== null ? (data.checkList.check[i-1].value == "0" ? false : true) : false;

            no.disabled = data.checkList.sign || readOnly ? "disabled" : "";
            no.checked = data.checkList.check[i-1].value !== null ? ((data.checkList.check[i-1].value == "0") ? true : false) : false;

            row.classList.remove('block-arrival');
            row.classList.add('block-departure');
        }

        buttonTurnaround.remove();
        let element = ("button");
        buttonTurnaround = document.createElement(element);
        buttonTurnaround.className = "btn btn-block block-arrival";
        buttonTurnaround.id = "buttonTurnaround";
        buttonTurnaround.name = data.turnaround.flightId;
        buttonTurnaround.textContent = data.turnaround.NR + " " + data.turnaround.BORT + "  " +
            (data.turnaround.factBeginAudit == null ? "-" : data.turnaround.factBeginAudit) + " / " +
            (data.turnaround.signDT == null ? "без подписи" : data.turnaround.signDT);
        buttonTurnaround.onclick = function () {

            let turnaround = JSON.parse(localStorage.getItem("turnaround"));

            if(turnaround["factBeginAudit"] == null)
            {
                loader.show();
                /*var PV = getDirection();
                checkList = {
                    "flightID": turnaround["flightID"],
                    "taskID": turnaround["taskID"],
                    "PV": turnaround["PV"]
                };*/
                m.request({
                    method: 'PUT',
                    url: '/api/task/logCreateAudit',
                    data: JSON.stringify(turnaround)
                }).then(function (response) {
                    loader.hide();

                    let info = {};
                    info['planDate'] = response["planDate"];
                    info['BORT'] = response["BORT"];
                    info['NR'] = response["NR"];
                    info['PV'] = response["PV"];
                    info['TS_ICAO'] = response["TS_ICAO"];

                    let audit = localStorage.getItem("checkList");
                    localStorage.setItem("checkList", JSON.stringify(response));
                    localStorage.setItem("turnaround", audit/*JSON.stringify(ctrl.checkList)*/);
                    localStorage.setItem("info", JSON.stringify(info));

                    printCheckList(true);
                    //let audit = JSON.parse(localStorage.getItem("checkList"));
                    //audit.check[Number(checkList.idTemplate)-1].value = checkList.check ? "1" : "0";
                    //localStorage.setItem("checkList", JSON.stringify(audit));
                }, function () {
                    loader.hide();
                });
            }
            else {
                let info = {};
                info['planDate'] = turnaround["planDate"];
                info['BORT'] = turnaround["BORT"];
                info['NR'] = turnaround["NR"];
                info['PV'] = turnaround["PV"];
                info['TS_ICAO'] = turnaround["TS_ICAO"];

                let audit = localStorage.getItem("checkList");
                localStorage.setItem("checkList", localStorage.getItem("turnaround")/*JSON.stringify(ctrl.turnaround)*/);
                localStorage.setItem("turnaround", audit/*JSON.stringify(ctrl.checkList)*/);
                localStorage.setItem("info", JSON.stringify(info));

                printCheckList(true);
            }

        };

        rowTurnaround.appendChild(buttonTurnaround);

        /*document.getElementById('resetAll').disabled = "disabled";
        document.getElementById('buttonCamera').disabled = "disabled";
        document.getElementById('commentCheckList').disabled = "disabled";
        document.getElementById('signAudit').disabled = "disabled";*/
    }


    var classDirection;
    var stringDirection;
    if(data.info.PV == 'П') {
        classDirection = "btn-info";
        stringDirection = "arrive";
    }
    else {
        classDirection = "btn-danger";
        stringDirection = "danger";
    }

    document.getElementById('resetAll').remove();

    let btnReset = document.createElement("button");
    btnReset.className = "btn btn-lg " + classDirection;
    btnReset.style = "width: 100%";
    btnReset.id = "resetAll";
    btnReset.disabled = data.checkList.sign || readOnly ? "disabled" : "";
    btnReset.textContent = "Сбросить всё";
    btnReset.onclick = function () {
        loader.show();
        var PV = getDirection();
        var checklist = { "flightID": data.checkList.flightID, "taskID": data.checkList.taskID, "PV": PV };
        m.request({
            method: 'PUT',
            url: '/api/task/' + m.route.param('taskId') + '/resetAuditCheck',
            data: checklist
        }).then(function (response) {
            loader.hide();
            for(let i = 1; i <= 9; i++) {
                let numb  = i.toString();
                let yes = document.getElementById('checkboxYes'+numb);
                let no = document.getElementById('checkboxNo'+numb);
                let text = document.getElementById("textComment"+numb);
                let icon = document.getElementById("icon"+numb);
                let comment = document.getElementById("comment"+numb);
                comment.hidden = true;
                yes.checked = false;
                no.checked = false;
                text.value = "";
                if(icon)
                    icon.remove();
            }
            let commonComment = document.getElementById("commentCheckList");
            commonComment.value = "";

            let audit = localStorage.getItem("checkList");
            audit = JSON.parse(audit);
            for(let i = 0; i < audit.check.length; i++) {
                audit.check[i].value = null;
                audit.check[i].comment = "";
            }
            audit.comment = "";
            localStorage.setItem("checkList", JSON.stringify(audit));
        }, function () {
            loader.hide();
        });
    };
    document.getElementById('tdResetAll').appendChild(btnReset);

    document.getElementById('buttonCamera').remove();

    let btnCamera = document.createElement("button");
    btnCamera.className = "btn btn-lg " + classDirection;
    btnCamera.style = "width: 100%";
    btnCamera.id = "buttonCamera";
    btnCamera.disabled = data.checkList.sign || readOnly ? "disabled" : "";
    btnCamera.textContent = "Фото";
    btnCamera.onclick = function () {
        document.getElementById("cameraFileInput").addEventListener("change", function () {
            var name = unixTimeToDate(this.files[0].lastModified);
            var dateTime = new Date();
            var size = this.files[0].size / 1000000;
            var photoUrl = window.URL.createObjectURL(this.files[0]);

            convertImgToBase64URLCheckList(photoUrl, function(base64Img){
                var base64Photo = base64Img;// Base64DataURL

                let checkList = localStorage.getItem("checkList");
                checkList = JSON.parse(checkList);

                for (let i = 0; i < checkList.photo.length; i++) {
                    if(checkList.photo[i].name == name) {
                        return;
                    }
                }
                checkList.photo.push({ "name": name, "dk": dateTime, "comment": '', "blobUrl": photoUrl, "base64Img": base64Photo });

                let value = JSON.stringify(checkList);

                localStorage.setItem("checkList", value);
                paintPhotoCheckList(localStorage.getItem("directionFlight"));
            });
        });
        const input = document.getElementById('cameraFileInput');
        input.focus();
        input.click();
    };
    document.getElementById('tdButtonCamera').appendChild(btnCamera);

    //Освобождение localStorage
    var conteiner = document.getElementById("pictureConteiner").innerHTML = "";
    //localStorage.removeItem("unsavedPhotoCheckList");
    //localStorage.setItem("unsavedPhotoCheckList", 1);

    //Отрисовка фото
    /*var photo = data.checkList.photo;

    var unsavedPhoto = JSON.parse(localStorage.getItem("unsavedPhotoCheckList"));
    var browserPhoto = unsavedPhoto;

    if (browserPhoto.length) {
        //unsavedPhoto = JSON.parse(unsavedPhoto);
        //browserPhoto = JSON.parse(browserPhoto);
        for (let i = 0; i < browserPhoto.length; i++) {
            for(let j = 0; j < photo.length; j++) {
                if (browserPhoto[i].name != photo[j].dk) {
                    unsavedPhoto.push({ "name": photo[j].dk, "dk": photo[j].dk, "comment": '', "blobUrl": '', "base64Img": photo[j].base64 });
                }
                else
                    continue;
            }
        }
    }
    else {
        unsavedPhoto = [];

        for(let j = 0; j < photo.length; j++) {
            unsavedPhoto.push({ "name": photo[j].dk, "dk": photo[j].dk, "comment": '', "blobUrl": '', "base64Img": photo[j].base64 });
        }
    }

    this.unsavedPhoto = unsavedPhoto;*/

    ///let value = JSON.stringify(unsavedPhoto);
    //localStorage.setItem("unsavedPhotoCheckList", value);
    paintPhotoCheckList(localStorage.getItem("directionFlight"), data["checkList"].sign);


    document.getElementById('signAudit').remove();

    let btnSign = document.createElement("button");
    btnSign.className = "btn btn-lg " + classDirection;
    btnSign.style = "width: 100%";
    btnSign.id = "signAudit";
    btnSign.disabled = data.checkList.sign || readOnly ? "disabled" : "";
    btnSign.textContent = "Подписать";
    btnSign.onclick = function () {
        let check = checkingFilling();
        if(check) {
            ModalContainerCHL.open("Подпись чек-листа");
            document.getElementById("yesBtnModalSignCheckList").addEventListener("click", function () {
                var canvas = document.getElementById("canvasSignCheckList");
                if(isCanvasBlank(canvas) == false)
                    saveCheckListDB();

                ModalContainerCHL.close();
            });
        }
        else {
            modalContainerWarningCheckList.open("Чек-лист не заполнен");
            //alert("Чек-лист не заполнен");
        }
    };
    document.getElementById('tdButtonSign').appendChild(btnSign);

    document.getElementById('commentCheckList').value = data.checkList.comment != null ? data.checkList.comment : "";
    document.getElementById('commentCheckList').disabled = data.checkList.sign || readOnly ? "disabled" : "";
}

export var DepartureFlightChecklistBlock = {
    controller: function (args) {
        this.data = args.data;
        this.info = args.data;
        this.checkList = args.checkList;
        this.turnaround = args.turnaround;
        this.showBookingBlock = args.showBookingBlock;

        let info = {};
        info['planDate'] = this.data.planDate;
        info['BORT'] = this.data.BORT;
        info['NR'] = this.data.NR;
        info['PV'] = this.data.PV;
        info['TS_ICAO'] = this.data.TS_ICAO;

        localStorage.setItem("checkList", JSON.stringify(this.checkList));
        localStorage.setItem("turnaround", JSON.stringify(this.turnaround));
        localStorage.setItem("info", JSON.stringify(info));

        if(this.turnaround != null && this.turnaround != "Борт не назначен!") {
            if (this.turnaround['factBeginAudit'] != null) {
                let dt = this.turnaround['factBeginAudit'].split(' ');
                let date = dt[0];
                let time = dt[1];

                let arrDate = date.split('-');
                date = arrDate[2] + "." + arrDate[1] + "." + arrDate[0];

                let arrTime = time.split(":");
                time = arrTime[0] + ":" + arrTime[1];

                this.turnaround['factBeginAudit'] = date + " " + time;
            }

            if (this.turnaround['signDT'] != null) {
                let time = this.turnaround['signDT'].split(' ')[1];
                let arrTime = time.split(":");
                time = arrTime[0] + ":" + arrTime[1];

                this.turnaround['signDT'] = time;
            }
        }

        if(this.checkList.sign)
            paintPhotoCheckList(localStorage.getItem("directionFlight"), this.checkList.sign);

    },
    view: function (ctrl) {
        return m(".container[id='container'][style='padding-top:10px']", [
            ctrl.checkList == 2 || ctrl.checkList == 1 ? [] : [
                ctrl.turnaround != null ? /*ctrl.turnaround['sign'] != false ?*/ m(".row[style='margin: 0 1px;'][id='rowTurnaround']", [
                    m("span.col-12[style='padding:0 10px 0 5px'][id='labelTurnaround']", "Чек-лист прилета:"),
                    m("button.btn.btn-block.block-arrival[style='border-radius: 5px'][id='buttonTurnaround']", {
                        onclick: function () {

                            let turnaround = JSON.parse(localStorage.getItem("turnaround"));
                            let checkList = JSON.parse(localStorage.getItem("checkList"));
                            //let readOnly = checkList["taskID"] == turnaround["taskID"] ? false : true;
                            let readOnly = true;

                            if(turnaround["factBeginAudit"] == null && !readOnly)
                            {
                                loader.show();
                                m.request({
                                    method: 'PUT',
                                    url: '/api/task/logCreateAudit',
                                    data: JSON.stringify(turnaround)
                                }).then(function (response) {
                                    loader.hide();

                                    let info = {};
                                    info['planDate'] = response["planDate"];
                                    info['BORT'] = response["BORT"];
                                    info['NR'] = response["NR"];
                                    info['PV'] = response["PV"];
                                    info['TS_ICAO'] = response["TS_ICAO"];

                                    let audit = localStorage.getItem("checkList");
                                    localStorage.setItem("checkList", JSON.stringify(response));
                                    localStorage.setItem("turnaround", audit/*JSON.stringify(ctrl.checkList)*/);
                                    localStorage.setItem("info", JSON.stringify(info));

                                    printCheckList();
                                }, function () {
                                    loader.hide();
                                });
                            }
                            else {
                                let info = {};
                                info['planDate'] = turnaround["planDate"];
                                info['BORT'] = turnaround["BORT"];
                                info['NR'] = turnaround["NR"];
                                info['PV'] = turnaround["PV"];
                                info['TS_ICAO'] = turnaround["TS_ICAO"];

                                let audit = localStorage.getItem("checkList");
                                localStorage.setItem("checkList", localStorage.getItem("turnaround"));
                                localStorage.setItem("turnaround", audit);
                                localStorage.setItem("info", JSON.stringify(info));

                                printCheckList(readOnly);
                            }
                        }
                    }, ctrl.turnaround.NR + " " + ctrl.turnaround.BORT + "  " + (ctrl.turnaround.factBeginAudit == null ? "-" : ctrl.turnaround.factBeginAudit) +
                        " / " + (ctrl.turnaround.signDT == null ? "без подписи" : ctrl.turnaround.signDT)),
                ]) : []/* : []*/
            ],

            ctrl.checkList == 2 || ctrl.checkList == 1 ? [] :
                [
                    m(".row", [
                        m(".col-xs-12.text-center[style='padding:7px']", [
                            m("strong[style='font-size:16px']", "ЧЕК ЛИСТ ВНЕШНЕГО ОСМОТРА ВС")
                        ])
                    ]),
                    m(".row", [
                        m(".col-xs-12.text-center[style='padding:7px']", [
                            m("strong[style='font-size:14px'][id='stageFlight']", "Начальный рейс")
                        ])
                    ]),
                    m(".row", [
                        m(".col-xs-3[style='padding:0 5px 0 10px']", [
                            m("span", "Дата"),
                            m("p.text-center.bg-danger[id='datePlane'][style='padding:10px 2px; font-size: 14px']", ctrl.data.planDate || m.trust("&nbsp;"))
                        ]),
                        m(".col-xs-3[style='padding:0 10px 0 5px']", [
                            m("span", "№ Рейса"),
                            m("p.text-center.bg-danger[id='NR'][style='padding:10px 2px; font-size: 14px']", ctrl.data.NR || m.trust("&nbsp;"))
                        ]),
                        m(".col-xs-3[style='padding:0 10px 0 5px']", [
                            m("span", "Рег. № ВС"),
                            m("p.text-center.bg-danger[id='BORT'][style='padding:10px 2px; font-size: 14px']", ctrl.data.BORT || m.trust("&nbsp;"))
                        ]),
                        m(".col-xs-3[style='padding:0 10px 0 5px']", [
                            m("span", "Тип ВС"),
                            m("p.text-center.bg-danger[id='TS_ICAO'][style='padding:10px 2px; font-size: 14px']", ctrl.data.TS_ICAO || m.trust("&nbsp;"))
                        ])
                    ]),
                    m(".row", [m("br", "")]),
                    m("table.table.table-bordered ", [
                        m("thead", [
                            m("tr", [
                                m("th.col-xs-8[rowspan='2'][style='vertical-align: middle']", [
                                    m(".text-center", "Зоны, элементы конструкции " +
                                        "ВС для осмотра. Соответствие ТУ."),
                                    //m("p.text-center.bg-danger", ctrl.data.BORT || m.trust("&nbsp;"))
                                ]),
                                m("th.col-xs-4[colspan='2'][style='vertical-align: middle']", [
                                    m(".text-center", "Отправление"),
                                    //m("p.text-center.bg-danger", ctrl.data.NST || m.trust("&nbsp;"))
                                ])
                            ]),
                            m("tr", [
                                m("th.col-xs-2[style='vertical-align: middle']", [
                                    m(".text-center", "ДА"),
                                    //m("p.text-center.bg-danger", ctrl.data.NST || m.trust("&nbsp;"))
                                ]),
                                m("th.col-xs-2[style='vertical-align: middle']", [
                                    m(".text-center", "НЕТ"),
                                    //m("p.text-center.bg-danger", ctrl.data.NST || m.trust("&nbsp;"))
                                ])
                            ])
                        ]),
                        m("tbody", [
                            ////////////////////////////////====1====/////////////////////////////////////////////
                            m("tr", [
                                m("td.col-xs-8.unselectable[style='vertical-align: middle'][id='td1']", [
                                    m("button[style='border-radius: 5px'][id='row1']", {
                                        class: "btn btn-block block-departure",
                                        onclick: function () {
                                            let comment = document.getElementById("comment1");

                                            if(comment.hidden)
                                                comment.hidden = false;
                                            else
                                                comment.hidden = true;
                                        }
                                    }, "Датчики, приемники воздушного давления  ", [(ctrl.checkList.check[0].comment.trim()) ? m("span.glyphicon.glyphicon-star[id='icon1']") : ""] ),
                                    m("div[style='padding:7px 15px'][id='comment1'][hidden]", [
                                        m("b", "Примечание"),
                                        m("div", [
                                            m("textarea.form-control[id='textComment1']", {
                                                disabled: ctrl.checkList.sign ? "disabled" : "",
                                                //readonly: true,
                                                onchange: function () {
                                                    let elemIcon = document.getElementById("icon1");
                                                    if(elemIcon == null && this.value.trim() != "") {
                                                        let row = document.getElementById("row1");
                                                        let element = ("span");
                                                        let icon = document.createElement(element);
                                                        icon.className = "glyphicon glyphicon-star";
                                                        icon.id = "icon1";
                                                        row.appendChild(icon);
                                                    }

                                                    if (elemIcon && this.value.trim() == "") {
                                                        document.getElementById("icon1").remove();
                                                    }

                                                    let audit = JSON.parse(localStorage.getItem("checkList"));
                                                    let flightID = audit.flightID;
                                                    let taskID = audit.taskID;

                                                    loader.show();
                                                    var PV = getDirection();
                                                    var checkList = { "check": null, "flightID": flightID, "taskID": taskID, "idTemplate": 1, "comment": this.value.trim(), "PV": PV };
                                                    m.request({
                                                        method: 'PUT',
                                                        url: '/api/task/' + m.route.param('taskId') + '/setAuditCheck',
                                                        data: checkList
                                                    }).then(function (response) {
                                                        loader.hide();
                                                        document.getElementById("comment1").hidden = true;

                                                        let audit = JSON.parse(localStorage.getItem("checkList"));
                                                        audit.check[Number(checkList.idTemplate)-1].comment = checkList.comment;
                                                        localStorage.setItem("checkList", JSON.stringify(audit));

                                                    }, function () {
                                                        loader.hide();
                                                    });
                                                }
                                            }, ctrl.checkList.check[0].comment.trim())
                                        ]),
                                    ]),
                                ]),
                                m("td.col-xs-2[style='vertical-align: middle; text-align: center;']", {
                                    onclick: function () {
                                        if(clickYes("1") !== 0)
                                            ctrl.checkList.check[0].value = true;
                                    }
                                }, [
                                    m("input.form-check-input [type='checkbox'][id='checkboxYes1']", {
                                        disabled: ctrl.checkList.sign ? "disabled" : "",
                                        checked: ctrl.checkList.check[0].value != null ? ctrl.checkList.check[0].value : false
                                    }),
                                ]),
                                m("td.col-xs-2[style='vertical-align: middle; text-align: center']", {
                                    onclick: function () {
                                        if(clickNo("1") !== 0)
                                            ctrl.checkList.check[0].value = false;
                                    }
                                }, [
                                    m("input.form-check-input [type='checkbox'][id='checkboxNo1']", {
                                        disabled: ctrl.checkList.sign ? "disabled" : "",
                                        checked: ctrl.checkList.check[0].value !== null ? ((ctrl.checkList.check[0].value == 0) ? true : false) : false
                                    }),
                                ])
                            ]),
                            ////////////////////////////////====2====/////////////////////////////////////////////
                            m("tr", [
                                m("td.col-xs-8[style='vertical-align: middle'][id='td2']", [
                                    m("button.btn.btn-block.block-departure[style='border-radius: 5px'][id='row2']", {
                                        onclick: function () {
                                            let comment = document.getElementById("comment2");
                                            if(comment.hidden)
                                                comment.hidden = false;
                                            else
                                                comment.hidden = true;
                                        }
                                    }, "Двери, дверные проемы, лючки и панели доступа  ", [(ctrl.checkList.check[1].comment.trim()) ? m("span.glyphicon.glyphicon-star[id='icon2']") : ""]),
                                    m("div[style='padding:7px 15px'][id='comment2'][hidden]", [
                                        m("b", "Примечание"),
                                        m("div", [
                                            m("textarea.form-control[id='textComment2']", {
                                                disabled: ctrl.checkList.sign ? "disabled" : "",
                                                onchange: function () {
                                                    let elemIcon = document.getElementById("icon2");
                                                    if(elemIcon == null && this.value.trim() != "") {
                                                        let row = document.getElementById("row2");
                                                        let element = ("span");
                                                        let icon = document.createElement(element);
                                                        icon.className = "glyphicon glyphicon-star";
                                                        icon.id = "icon2";
                                                        row.appendChild(icon);
                                                    }

                                                    if (elemIcon && this.value.trim() == "") {
                                                        document.getElementById("icon2").remove();
                                                    }

                                                    let audit = JSON.parse(localStorage.getItem("checkList"));
                                                    let flightID = audit.flightID;
                                                    let taskID = audit.taskID;

                                                    loader.show();
                                                    var PV = getDirection();
                                                    var checkList = { "check": null, "flightID": flightID, "taskID": taskID, "idTemplate": 2, "comment": this.value.trim(), "PV": PV };
                                                    m.request({
                                                        method: 'PUT',
                                                        url: '/api/task/' + m.route.param('taskId') + '/setAuditCheck',
                                                        data: checkList
                                                    }).then(function (response) {
                                                        loader.hide();
                                                        document.getElementById("comment2").hidden = true;

                                                        let audit = JSON.parse(localStorage.getItem("checkList"));
                                                        audit.check[Number(checkList.idTemplate)-1].comment = checkList.comment;
                                                        localStorage.setItem("checkList", JSON.stringify(audit));
                                                    }, function () {
                                                        loader.hide();
                                                    });
                                                }
                                            }, ctrl.checkList.check[1].comment.trim()),
                                        ]),
                                    ]),
                                    //m("p.text-center.bg-danger", ctrl.data.NST || m.trust("&nbsp;"))
                                ]),
                                m("td.col-xs-2[style='vertical-align: middle; text-align: center']", {
                                    onclick: function () {
                                        if(clickYes("2", ctrl.checkList.flightID, ctrl.checkList.taskID) !== 0)
                                            ctrl.checkList.check[1].value = true;
                                    }
                                }, [
                                    m("input.form-check-input [type='checkbox'][id='checkboxYes2']", {
                                        disabled: ctrl.checkList.sign ? "disabled" : "",
                                        checked: ctrl.checkList.check[1].value != null ? ctrl.checkList.check[1].value : false
                                    }),
                                    //m("p.text-center.bg-danger", ctrl.data.NST || m.trust("&nbsp;"))
                                ]),
                                m("td.col-xs-2[style='vertical-align: middle; text-align: center']", {
                                    onclick: function () {
                                        if(clickNo("2") !== 0)
                                            ctrl.checkList.check[1].value = false;
                                    }
                                }, [
                                    m("input.form-check-input [type='checkbox'][id='checkboxNo2']", {
                                        disabled: ctrl.checkList.sign ? "disabled" : "",
                                        checked: ctrl.checkList.check[1].value !== null ? ((ctrl.checkList.check[1].value == 0) ? true : false) : false
                                    }),
                                    //m("p.text-center.bg-danger", ctrl.data.NST || m.trust("&nbsp;"))
                                ])
                            ]),
                            ////////////////////////////////====3====/////////////////////////////////////////////
                            m("tr", [
                                m("td.col-xs-8[style='vertical-align: middle'][id='td3']", [
                                    m("button.btn.btn-block.block-departure[style='border-radius: 5px'][id='row3']", {
                                        onclick: function () {
                                            let comment = document.getElementById("comment3");
                                            if(comment.hidden)
                                                comment.hidden = false;
                                            else
                                                comment.hidden = true;
                                        }
                                    }, "Обтекатель радара  ", [(ctrl.checkList.check[2].comment.trim()) ? m("span.glyphicon.glyphicon-star[id='icon3']") : ""]),
                                    m("div[style='padding:7px 15px'][id='comment3'][hidden]", [
                                        m("b", "Примечание"),
                                        m("div", [
                                            m("textarea.form-control[id='textComment3']", {
                                                disabled: ctrl.checkList.sign ? "disabled" : "",
                                                onchange: function () {
                                                    let elemIcon = document.getElementById("icon3");
                                                    if(elemIcon == null && this.value.trim() != "") {
                                                        let row = document.getElementById("row3");
                                                        let element = ("span");
                                                        let icon = document.createElement(element);
                                                        icon.className = "glyphicon glyphicon-star";
                                                        icon.id = "icon3";
                                                        row.appendChild(icon);
                                                    }

                                                    if (elemIcon && this.value.trim() == "") {
                                                        document.getElementById("icon3").remove();
                                                    }

                                                    let audit = JSON.parse(localStorage.getItem("checkList"));
                                                    let flightID = audit.flightID;
                                                    let taskID = audit.taskID;

                                                    loader.show();
                                                    var PV = getDirection();
                                                    var checkList = { "check": null, "flightID": flightID, "taskID": taskID, "idTemplate": 3, "comment": this.value.trim(), "PV": PV };
                                                    m.request({
                                                        method: 'PUT',
                                                        url: '/api/task/' + m.route.param('taskId') + '/setAuditCheck',
                                                        data: checkList
                                                    }).then(function (response) {
                                                        loader.hide();
                                                        document.getElementById("comment3").hidden = true;

                                                        let audit = JSON.parse(localStorage.getItem("checkList"));
                                                        audit.check[Number(checkList.idTemplate)-1].comment = checkList.comment;
                                                        localStorage.setItem("checkList", JSON.stringify(audit));
                                                    }, function () {
                                                        loader.hide();
                                                    });
                                                }
                                            }, ctrl.checkList.check[2].comment.trim()),
                                        ]),
                                    ]),
                                    //m("p.text-center.bg-danger", ctrl.data.NST || m.trust("&nbsp;"))
                                ]),
                                m("td.col-xs-2[style='vertical-align: middle; text-align: center']", {
                                    onclick: function () {
                                        if(clickYes("3", ctrl.checkList.flightID, ctrl.checkList.taskID) !== 0)
                                            ctrl.checkList.check[2].value = true;
                                    }
                                }, [
                                    m("input.form-check-input [type='checkbox'][id='checkboxYes3']", {
                                        disabled: ctrl.checkList.sign ? "disabled" : "",
                                        checked: ctrl.checkList.check[2].value != null ? ctrl.checkList.check[2].value : false
                                    }),
                                    //m("p.text-center.bg-danger", ctrl.data.NST || m.trust("&nbsp;"))
                                ]),
                                m("td.col-xs-2[style='vertical-align: middle; text-align: center']", {
                                    onclick: function () {
                                        if(clickNo("3") !== 0)
                                            ctrl.checkList.check[2].value = false;
                                    }
                                }, [
                                    m("input.form-check-input [type='checkbox'][id='checkboxNo3']", {
                                        disabled: ctrl.checkList.sign ? "disabled" : "",
                                        checked: ctrl.checkList.check[2].value !== null ? ((ctrl.checkList.check[2].value == 0) ? true : false) : false
                                    }),
                                    //m("p.text-center.bg-danger", ctrl.data.NST || m.trust("&nbsp;"))
                                ])
                            ]),
                            ////////////////////////////////====4====/////////////////////////////////////////////
                            m("tr", [
                                m("td.col-xs-8[style='vertical-align: middle'][id='td4']", [
                                    m("button.btn.btn-block.block-departure[style='border-radius: 5px'][id='row4']", {
                                        onclick: function () {
                                            let comment = document.getElementById("comment4");
                                            if(comment.hidden)
                                                comment.hidden = false;
                                            else
                                                comment.hidden = true;
                                        }
                                    }, "Передняя опора шасси, створки, фары  ", [(ctrl.checkList.check[3].comment.trim()) ? m("span.glyphicon.glyphicon-star[id='icon4']") : ""]),
                                    m("div[style='padding:7px 15px'][id='comment4'][hidden]", [
                                        m("b", "Примечание"),
                                        m("div", [
                                            m("textarea.form-control[id='textComment4']", {
                                                disabled: ctrl.checkList.sign ? "disabled" : "",
                                                onchange: function () {
                                                    let elemIcon = document.getElementById("icon4");
                                                    if(elemIcon == null && this.value.trim() != "") {
                                                        let row = document.getElementById("row4");
                                                        let element = ("span");
                                                        let icon = document.createElement(element);
                                                        icon.className = "glyphicon glyphicon-star";
                                                        icon.id = "icon4";
                                                        row.appendChild(icon);
                                                    }

                                                    if (elemIcon && this.value.trim() == "") {
                                                        document.getElementById("icon4").remove();
                                                    }

                                                    let audit = JSON.parse(localStorage.getItem("checkList"));
                                                    let flightID = audit.flightID;
                                                    let taskID = audit.taskID;

                                                    loader.show();
                                                    var PV = getDirection();
                                                    var checkList = { "check": null, "flightID": flightID, "taskID": taskID, "idTemplate": 4, "comment": this.value.trim(), "PV": PV };
                                                    m.request({
                                                        method: 'PUT',
                                                        url: '/api/task/' + m.route.param('taskId') + '/setAuditCheck',
                                                        data: checkList
                                                    }).then(function (response) {
                                                        loader.hide();
                                                        document.getElementById("comment4").hidden = true;

                                                        let audit = JSON.parse(localStorage.getItem("checkList"));
                                                        audit.check[Number(checkList.idTemplate)-1].comment = checkList.comment;
                                                        localStorage.setItem("checkList", JSON.stringify(audit));
                                                    }, function () {
                                                        loader.hide();
                                                    });
                                                }
                                            }, ctrl.checkList.check[3].comment.trim()),
                                        ]),
                                    ]),
                                    //m("p.text-center.bg-danger", ctrl.data.NST || m.trust("&nbsp;"))
                                ]),
                                m("td.col-xs-2[style='vertical-align: middle; text-align: center']", {
                                    onclick: function () {
                                        if(clickYes("4", ctrl.checkList.flightID, ctrl.checkList.taskID) !== 0)
                                            ctrl.checkList.check[3].value = true;
                                    }
                                }, [
                                    m("input.form-check-input [type='checkbox'][id='checkboxYes4']", {
                                        disabled: ctrl.checkList.sign ? "disabled" : "",
                                        checked: ctrl.checkList.check[3].value != null ? ctrl.checkList.check[3].value : false
                                    }),
                                    //m("p.text-center.bg-danger", ctrl.data.NST || m.trust("&nbsp;"))
                                ]),
                                m("td.col-xs-2[style='vertical-align: middle; text-align: center']", {
                                    onclick: function () {
                                        if(clickNo("4") !== 0)
                                            ctrl.checkList.check[3].value = false;
                                    }
                                }, [
                                    m("input.form-check-input [type='checkbox'][id='checkboxNo4']", {
                                        disabled: ctrl.checkList.sign ? "disabled" : "",
                                        checked: ctrl.checkList.check[3].value !== null ? ((ctrl.checkList.check[3].value == 0) ? true : false) : false
                                    }),
                                    //m("p.text-center.bg-danger", ctrl.data.NST || m.trust("&nbsp;"))
                                ])
                            ]),
                            ////////////////////////////////====5====/////////////////////////////////////////////
                            m("tr", [
                                m("td.col-xs-8[style='vertical-align: middle'][id='td5']", [
                                    m("button.btn.btn-block.block-departure[style='border-radius: 5px'][id='row5']", {
                                        onclick: function () {
                                            let comment = document.getElementById("comment5");
                                            if(comment.hidden)
                                                comment.hidden = false;
                                            else
                                                comment.hidden = true;
                                        }
                                    }, "Фюзеляж, антенны, сливные насадки, фары, маяки  ", [(ctrl.checkList.check[4].comment.trim()) ? m("span.glyphicon.glyphicon-star[id='icon5']") : ""]),
                                    m("div[style='padding:7px 15px'][id='comment5'][hidden]", [
                                        m("b", "Примечание"),
                                        m("div", [
                                            m("textarea.form-control[id='textComment5']", {
                                                disabled: ctrl.checkList.sign ? "disabled" : "",
                                                onchange: function () {
                                                    let elemIcon = document.getElementById("icon5");
                                                    if(elemIcon == null && this.value.trim() != "") {
                                                        let row = document.getElementById("row5");
                                                        let element = ("span");
                                                        let icon = document.createElement(element);
                                                        icon.className = "glyphicon glyphicon-star";
                                                        icon.id = "icon5";
                                                        row.appendChild(icon);
                                                    }

                                                    if (elemIcon && this.value.trim() == "") {
                                                        document.getElementById("icon5").remove();
                                                    }

                                                    let audit = JSON.parse(localStorage.getItem("checkList"));
                                                    let flightID = audit.flightID;
                                                    let taskID = audit.taskID;

                                                    loader.show();
                                                    var PV = getDirection();
                                                    var checkList = { "check": null, "flightID": flightID, "taskID": taskID, "idTemplate": 5, "comment": this.value.trim(), "PV": PV };
                                                    m.request({
                                                        method: 'PUT',
                                                        url: '/api/task/' + m.route.param('taskId') + '/setAuditCheck',
                                                        data: checkList
                                                    }).then(function (response) {
                                                        loader.hide();
                                                        document.getElementById("comment5").hidden = true;

                                                        let audit = JSON.parse(localStorage.getItem("checkList"));
                                                        audit.check[Number(checkList.idTemplate)-1].comment = checkList.comment;
                                                        localStorage.setItem("checkList", JSON.stringify(audit));
                                                    }, function () {
                                                        loader.hide();
                                                    });
                                                }
                                            }, ctrl.checkList.check[4].comment.trim()),
                                        ]),
                                    ]),
                                    //m("p.text-center.bg-danger", ctrl.data.NST || m.trust("&nbsp;"))
                                ]),
                                m("td.col-xs-2[style='vertical-align: middle; text-align: center']", {
                                    onclick: function () {
                                        if(clickYes("5", ctrl.checkList.flightID, ctrl.checkList.taskID) !== 0)
                                            ctrl.checkList.check[4].value = true;
                                    }
                                }, [
                                    m("input.form-check-input [type='checkbox'][id='checkboxYes5']", {
                                        disabled: ctrl.checkList.sign ? "disabled" : "",
                                        checked: ctrl.checkList.check[4].value != null ? ctrl.checkList.check[4].value : false
                                    }),
                                    //m("p.text-center.bg-danger", ctrl.data.NST || m.trust("&nbsp;"))
                                ]),
                                m("td.col-xs-2[style='vertical-align: middle; text-align: center']", {
                                    onclick: function () {
                                        if(clickNo("5") !== 0)
                                            ctrl.checkList.check[4].value = false;
                                    }
                                }, [
                                    m("input.form-check-input [type='checkbox'][id='checkboxNo5']", {
                                        disabled: ctrl.checkList.sign ? "disabled" : "",
                                        checked: ctrl.checkList.check[4].value !== null ? ((ctrl.checkList.check[4].value == 0) ? true : false) : false
                                    }),
                                    //m("p.text-center.bg-danger", ctrl.data.NST || m.trust("&nbsp;"))
                                ])
                            ]),
                            ////////////////////////////////====6====/////////////////////////////////////////////
                            m("tr", [
                                m("td.col-xs-8[style='vertical-align: middle'][id='td6']", [
                                    m("button.btn.btn-block.block-departure[style='border-radius: 5px'][id='row6']", {
                                        onclick: function () {
                                            let comment = document.getElementById("comment6");
                                            if(comment.hidden)
                                                comment.hidden = false;
                                            else
                                                comment.hidden = true;
                                        }
                                    }, "Двигатели, воздухозаборники, лопатки вентилятора, створки капотов, лючки  ", [(ctrl.checkList.check[5].comment.trim()) ? m("span.glyphicon.glyphicon-star[id='icon6']") : ""]),
                                    m("div[style='padding:7px 15px'][id='comment6'][hidden]", [
                                        m("b", "Примечание"),
                                        m("div", [
                                            m("textarea.form-control[id='textComment6']", {
                                                disabled: ctrl.checkList.sign ? "disabled" : "",
                                                onchange: function () {
                                                    let elemIcon = document.getElementById("icon6");
                                                    if(elemIcon == null && this.value.trim() != "") {
                                                        let row = document.getElementById("row6");
                                                        let element = ("span");
                                                        let icon = document.createElement(element);
                                                        icon.className = "glyphicon glyphicon-star";
                                                        icon.id = "icon6";
                                                        row.appendChild(icon);
                                                    }

                                                    if (elemIcon && this.value.trim() == "") {
                                                        document.getElementById("icon6").remove();
                                                    }

                                                    let audit = JSON.parse(localStorage.getItem("checkList"));
                                                    let flightID = audit.flightID;
                                                    let taskID = audit.taskID;

                                                    loader.show();
                                                    var PV = getDirection();
                                                    var checkList = { "check": null, "flightID": flightID, "taskID": taskID, "idTemplate": 6, "comment": this.value.trim(), "PV": PV };
                                                    m.request({
                                                        method: 'PUT',
                                                        url: '/api/task/' + m.route.param('taskId') + '/setAuditCheck',
                                                        data: checkList
                                                    }).then(function (response) {
                                                        loader.hide();
                                                        document.getElementById("comment6").hidden = true;

                                                        let audit = JSON.parse(localStorage.getItem("checkList"));
                                                        audit.check[Number(checkList.idTemplate)-1].comment = checkList.comment;
                                                        localStorage.setItem("checkList", JSON.stringify(audit));
                                                    }, function () {
                                                        loader.hide();
                                                    });
                                                }
                                            }, ctrl.checkList.check[5].comment.trim()),
                                        ]),
                                    ]),
                                    //m("p.text-center.bg-danger", ctrl.data.NST || m.trust("&nbsp;"))
                                ]),
                                m("td.col-xs-2[style='vertical-align: middle; text-align: center']", {
                                    onclick: function () {
                                        if(clickYes("6", ctrl.checkList.flightID, ctrl.checkList.taskID) !== 0)
                                            ctrl.checkList.check[5].value = true;
                                    }
                                }, [
                                    m("input.form-check-input [type='checkbox'][id='checkboxYes6']", {
                                        disabled: ctrl.checkList.sign ? "disabled" : "",
                                        checked: ctrl.checkList.check[5].value != null ? ctrl.checkList.check[5].value : false
                                    }),
                                    //m("p.text-center.bg-danger", ctrl.data.NST || m.trust("&nbsp;"))
                                ]),
                                m("td.col-xs-2[style='vertical-align: middle; text-align: center']", {
                                    onclick: function () {
                                        if(clickNo("6") !== 0)
                                            ctrl.checkList.check[5].value = false;
                                    }
                                }, [
                                    m("input.form-check-input [type='checkbox'][id='checkboxNo6']", {
                                        disabled: ctrl.checkList.sign ? "disabled" : "",
                                        checked: ctrl.checkList.check[5].value !== null ? ((ctrl.checkList.check[5].value == 0) ? true : false) : false
                                    }),
                                    //m("p.text-center.bg-danger", ctrl.data.NST || m.trust("&nbsp;"))
                                ])
                            ]),
                            ////////////////////////////////====7====/////////////////////////////////////////////
                            m("tr", [
                                m("td.col-xs-8[style='vertical-align: middle'][id='td7']", [
                                    m("button.btn.btn-block.block-departure[style='border-radius: 5px'][id='row7']", {
                                            onclick: function () {
                                                let comment = document.getElementById("comment7");
                                                if(comment.hidden)
                                                    comment.hidden = false;
                                                else
                                                    comment.hidden = true;
                                            }
                                        }, "Крыло, предкрылки, закрылки, элероны, обтекатели механизации крыла, аэронавигационные и проблесковые огни,  статические разрядники  ",
                                        [(ctrl.checkList.check[6].comment.trim()) ? m("span.glyphicon.glyphicon-star[id='icon7']") : ""]),
                                    m("div[style='padding:7px 15px'][id='comment7'][hidden]", [
                                        m("b", "Примечание"),
                                        m("div", [
                                            m("textarea.form-control[id='textComment7']", {
                                                disabled: ctrl.checkList.sign ? "disabled" : "",
                                                onchange: function () {
                                                    let elemIcon = document.getElementById("icon7");
                                                    if(elemIcon == null && this.value.trim() != "") {
                                                        let row = document.getElementById("row7");
                                                        let element = ("span");
                                                        let icon = document.createElement(element);
                                                        icon.className = "glyphicon glyphicon-star";
                                                        icon.id = "icon7";
                                                        row.appendChild(icon);
                                                    }

                                                    if (elemIcon && this.value.trim() == "") {
                                                        document.getElementById("icon7").remove();
                                                    }

                                                    let audit = JSON.parse(localStorage.getItem("checkList"));
                                                    let flightID = audit.flightID;
                                                    let taskID = audit.taskID;

                                                    loader.show();
                                                    var PV = getDirection();
                                                    var checkList = { "check": null, "flightID": flightID, "taskID": taskID, "idTemplate": 7, "comment": this.value.trim(), "PV": PV };
                                                    m.request({
                                                        method: 'PUT',
                                                        url: '/api/task/' + m.route.param('taskId') + '/setAuditCheck',
                                                        data: checkList
                                                    }).then(function (response) {
                                                        loader.hide();
                                                        document.getElementById("comment7").hidden = true;

                                                        let audit = JSON.parse(localStorage.getItem("checkList"));
                                                        audit.check[Number(checkList.idTemplate)-1].comment = checkList.comment;
                                                        localStorage.setItem("checkList", JSON.stringify(audit));
                                                    }, function () {
                                                        loader.hide();
                                                    });
                                                }
                                            }, ctrl.checkList.check[6].comment.trim()),
                                        ]),
                                    ]),
                                    //m("p.text-center.bg-danger", ctrl.data.NST || m.trust("&nbsp;"))
                                ]),
                                m("td.col-xs-2[style='vertical-align: middle; text-align: center']", {
                                    onclick: function () {
                                        if(clickYes("7", ctrl.checkList.flightID, ctrl.checkList.taskID) !== 0)
                                            ctrl.checkList.check[6].value = true;
                                    }
                                }, [
                                    m("input.form-check-input [type='checkbox'][id='checkboxYes7']", {
                                        disabled: ctrl.checkList.sign ? "disabled" : "",
                                        checked: ctrl.checkList.check[6].value != null ? ctrl.checkList.check[6].value : false
                                    }),
                                    //m("p.text-center.bg-danger", ctrl.data.NST || m.trust("&nbsp;"))
                                ]),
                                m("td.col-xs-2[style='vertical-align: middle; text-align: center']", {
                                    onclick: function () {
                                        if(clickNo("7") !== 0)
                                            ctrl.checkList.check[6].value = false;
                                    }
                                }, [
                                    m("input.form-check-input [type='checkbox'][id='checkboxNo7']", {
                                        disabled: ctrl.checkList.sign ? "disabled" : "",
                                        checked: ctrl.checkList.check[6].value !== null ? ((ctrl.checkList.check[6].value == 0) ? true : false) : false
                                    }),
                                    //m("p.text-center.bg-danger", ctrl.data.NST || m.trust("&nbsp;"))
                                ])
                            ]),
                            ////////////////////////////////====8====/////////////////////////////////////////////
                            m("tr", [
                                m("td.col-xs-8[style='vertical-align: middle'][id='td8']", [
                                    m("button.btn.btn-block.block-departure[style='border-radius: 5px'][id='row8']", {
                                        onclick: function () {
                                            let comment = document.getElementById("comment8");
                                            if(comment.hidden)
                                                comment.hidden = false;
                                            else
                                                comment.hidden = true;
                                        }
                                    }, "Основные опоры шасси, шины, стойки, створки  ", [(ctrl.checkList.check[7].comment.trim()) ? m("span.glyphicon.glyphicon-star[id='icon8']") : ""]),
                                    m("div[style='padding:7px 15px'][id='comment8'][hidden]", [
                                        m("b", "Примечание"),
                                        m("div", [
                                            m("textarea.form-control[id='textComment8']", {
                                                disabled: ctrl.checkList.sign ? "disabled" : "",
                                                onchange: function () {
                                                    let elemIcon = document.getElementById("icon8");
                                                    if(elemIcon == null && this.value.trim() != "") {
                                                        let row = document.getElementById("row8");
                                                        let element = ("span");
                                                        let icon = document.createElement(element);
                                                        icon.className = "glyphicon glyphicon-star";
                                                        icon.id = "icon8";
                                                        row.appendChild(icon);
                                                    }

                                                    if (elemIcon && this.value.trim() == "") {
                                                        document.getElementById("icon8").remove();
                                                    }

                                                    let audit = JSON.parse(localStorage.getItem("checkList"));
                                                    let flightID = audit.flightID;
                                                    let taskID = audit.taskID;

                                                    loader.show();
                                                    var PV = getDirection();
                                                    var checkList = { "check": null, "flightID": flightID, "taskID": taskID, "idTemplate": 8, "comment": this.value.trim(), "PV": PV };
                                                    m.request({
                                                        method: 'PUT',
                                                        url: '/api/task/' + m.route.param('taskId') + '/setAuditCheck',
                                                        data: checkList
                                                    }).then(function (response) {
                                                        loader.hide();
                                                        document.getElementById("comment8").hidden = true;

                                                        let audit = JSON.parse(localStorage.getItem("checkList"));
                                                        audit.check[Number(checkList.idTemplate)-1].comment = checkList.comment;
                                                        localStorage.setItem("checkList", JSON.stringify(audit));
                                                    }, function () {
                                                        loader.hide();
                                                    });
                                                }
                                            }, ctrl.checkList.check[7].comment.trim()),
                                        ]),
                                    ]),
                                    //m("p.text-center.bg-danger", ctrl.data.NST || m.trust("&nbsp;"))
                                ]),
                                m("td.col-xs-2[style='vertical-align: middle; text-align: center']", {
                                    onclick: function () {
                                        if(clickYes("8", ctrl.checkList.flightID, ctrl.checkList.taskID) !== 0)
                                            ctrl.checkList.check[7].value = true;
                                    }
                                }, [
                                    m("input.form-check-input [type='checkbox'][id='checkboxYes8']", {
                                        disabled: ctrl.checkList.sign ? "disabled" : "",
                                        checked: ctrl.checkList.check[7].value != null ? ctrl.checkList.check[7].value : false
                                    }),
                                    //m("p.text-center.bg-danger", ctrl.data.NST || m.trust("&nbsp;"))
                                ]),
                                m("td.col-xs-2[style='vertical-align: middle; text-align: center']", {
                                    onclick: function () {
                                        if(clickNo("8") !== 0)
                                            ctrl.checkList.check[7].value = false;
                                    }
                                }, [
                                    m("input.form-check-input [type='checkbox'][id='checkboxNo8']", {
                                        disabled: ctrl.checkList.sign ? "disabled" : "",
                                        checked: ctrl.checkList.check[7].value !== null ? ((ctrl.checkList.check[7].value == 0) ? true : false) : false
                                    }),
                                    //m("p.text-center.bg-danger", ctrl.data.NST || m.trust("&nbsp;"))
                                ])
                            ]),
                            ////////////////////////////////====9====/////////////////////////////////////////////
                            m("tr", [
                                m("td.col-xs-8[style='vertical-align: middle'][id='td9']", [
                                    m("button.btn.btn-block.block-departure[style='border-radius: 5px'][id='row9']", {
                                            onclick: function () {
                                                let comment = document.getElementById("comment9");
                                                if(comment.hidden)
                                                    comment.hidden = false;
                                                else
                                                    comment.hidden = true;
                                            }
                                        }, "Хвостовое оперение, вертикальный стабилизатор и руль направления, горизонтальный стабилизатор и руль высоты, хвостовая опора, воздухозаборник ВСУ и сопло, статические разрядники, проблесковые огни  ",
                                        [(ctrl.checkList.check[8].comment.trim()) ? m("span.glyphicon.glyphicon-star[id='icon9']") : ""]),
                                    m("div[style='padding:7px 15px'][id='comment9'][hidden]", [
                                        m("b", "Примечание"),
                                        m("div", [
                                            m("textarea.form-control[id='textComment9']", {
                                                disabled: ctrl.checkList.sign ? "disabled" : "",
                                                onchange: function () {
                                                    let elemIcon = document.getElementById("icon9");
                                                    if(elemIcon == null && this.value.trim() != "") {
                                                        let row = document.getElementById("row9");
                                                        let element = ("span");
                                                        let icon = document.createElement(element);
                                                        icon.className = "glyphicon glyphicon-star";
                                                        icon.id = "icon9";
                                                        row.appendChild(icon);
                                                    }

                                                    if (elemIcon && this.value.trim() == "") {
                                                        document.getElementById("icon9").remove();
                                                    }

                                                    let audit = JSON.parse(localStorage.getItem("checkList"));
                                                    let flightID = audit.flightID;
                                                    let taskID = audit.taskID;

                                                    loader.show();
                                                    var PV = getDirection();
                                                    var checkList = { "check": null, "flightID": flightID, "taskID": taskID, "idTemplate": 9, "comment": this.value.trim(), "PV": PV };
                                                    m.request({
                                                        method: 'PUT',
                                                        url: '/api/task/' + m.route.param('taskId') + '/setAuditCheck',
                                                        data: checkList
                                                    }).then(function (response) {
                                                        loader.hide();
                                                        document.getElementById("comment9").hidden = true;

                                                        let audit = JSON.parse(localStorage.getItem("checkList"));
                                                        audit.check[Number(checkList.idTemplate)-1].comment = checkList.comment;
                                                        localStorage.setItem("checkList", JSON.stringify(audit));
                                                    }, function () {
                                                        loader.hide();
                                                    });
                                                }
                                            }, ctrl.checkList.check[8].comment.trim()),
                                        ]),
                                    ]),
                                    //m("p.text-center.bg-danger", ctrl.data.NST || m.trust("&nbsp;"))
                                ]),
                                m("td.col-xs-2[style='vertical-align: middle; text-align: center']", {
                                    onclick: function () {
                                        if(clickYes("9", ctrl.checkList.flightID, ctrl.checkList.taskID) !== 0)
                                            ctrl.checkList.check[8].value = true;
                                    }
                                }, [
                                    m("input.form-check-input [type='checkbox'][id='checkboxYes9']", {
                                        disabled: ctrl.checkList.sign ? "disabled" : "",
                                        checked: ctrl.checkList.check[8].value != null ? ctrl.checkList.check[8].value : false
                                    }),
                                    //m("p.text-center.bg-danger", ctrl.data.NST || m.trust("&nbsp;"))
                                ]),
                                m("td.col-xs-2[style='vertical-align: middle; text-align: center']", {
                                    onclick: function () {
                                        if(clickNo("9") !== 0)
                                            ctrl.checkList.check[8].value = false;
                                    }
                                }, [
                                    m("input.form-check-input [type='checkbox'][id='checkboxNo9']", {
                                        disabled: ctrl.checkList.sign ? "disabled" : "",
                                        checked: ctrl.checkList.check[8].value !== null ? ((ctrl.checkList.check[8].value == 0) ? true : false) : false
                                    }),
                                    //m("p.text-center.bg-danger", ctrl.data.NST || m.trust("&nbsp;"))
                                ])
                            ]),

                        ])
                    ]),
                    m("table.table.table", [
                        m("tr", [
                            m("td.col-xs-8[colspan='8'][style='text-align: right']", ["Очистить чек-лист"]),
                            m("td.col-xs-4[colspan='4'][style='text-align: right; padding:2px 7px;'][id='tdResetAll']", [
                                m("button.btn.btn-danger.btn-lg[style='width:100%'][id='resetAll']", {
                                    disabled: ctrl.checkList.sign ? "disabled" : "",
                                    onclick: function () {
                                        for(let i = 1; i <= 9; i++) {
                                            let numb  = i.toString();
                                            let yes = document.getElementById('checkboxYes'+numb);
                                            let no = document.getElementById('checkboxNo'+numb);
                                            let text = document.getElementById("textComment"+numb);
                                            let icon = document.getElementById("icon"+numb);
                                            let comment = document.getElementById("comment"+numb);
                                            //let saveButton = document.getElementById("saveButton"+numb);
                                            comment.hidden = true;
                                            yes.checked = false;
                                            no.checked = false;
                                            //text.readOnly = false;
                                            //saveButton.disabled = false;
                                            text.value = "";
                                            if(icon)
                                                icon.remove();
                                        }
                                        let commonComment = document.getElementById("commentCheckList");
                                        commonComment.value = "";
                                        loader.show();
                                        var PV = getDirection();
                                        var checklist = { "flightID": ctrl.checkList.flightID, "taskID": ctrl.checkList.taskID, "PV": PV };
                                        m.request({
                                            method: 'PUT',
                                            url: '/api/task/' + m.route.param('taskId') + '/resetAuditCheck',
                                            data: checklist
                                        }).then(function (response) {
                                            loader.hide();
                                            let audit = localStorage.getItem("checkList");
                                            audit = JSON.parse(audit);
                                            for(let i = 0; i < audit.check.length; i++) {
                                                audit.check[i].value = null;
                                                audit.check[i].comment = "";
                                            }
                                            audit.comment = "";
                                            localStorage.setItem("checkList", JSON.stringify(audit));

                                        }, function () {
                                            loader.hide();
                                        });

                                    }
                                },"Сбросить всё")
                            ]),
                        ]),
                        m("tr", [
                            m("td.col-xs-8[colspan='8'][style='text-align: right']", ["Сделать фото"]),
                            m("td.col-xs-4[colspan='4'][style='text-align: right; padding:2px 7px;'][id='tdButtonCamera']", [
                                m("button.btn.btn-danger.btn-lg[style='width:100%'][id='buttonCamera']", {
                                    disabled: ctrl.checkList.sign ? "disabled" : "",
                                    onclick: function () {
                                        document.getElementById("cameraFileInput").addEventListener("change", function () {
                                            var name = unixTimeToDate(this.files[0].lastModified); //new Date()
                                            var dateTime = new Date();
                                            var size = this.files[0].size / 1000000;
                                            var photoUrl = window.URL.createObjectURL(this.files[0]);

                                            convertImgToBase64URLCheckList(photoUrl, function(base64Img){
                                                var base64Photo = base64Img;// Base64DataURL
                                                //let unsavedPhoto = localStorage.getItem("unsavedPhotoCheckList");
                                                let checkList = localStorage.getItem("checkList");
                                                checkList = JSON.parse(checkList);
                                                //if(checklist.photo.length) {
                                                for (let i = 0; i < checkList.photo.length; i++) {
                                                    if(checkList.photo[i].name == name) {
                                                        return;
                                                    }
                                                }
                                                //}
                                                /*if (unsavedPhoto) {
                                                    unsavedPhoto = JSON.parse(unsavedPhoto);
                                                    for (let i = 0; i < unsavedPhoto.length; i++) {
                                                        if(unsavedPhoto[i].name == name) {
                                                            return;
                                                        }
                                                    }
                                                }
                                                else
                                                    unsavedPhoto = [];
                                                 */

                                                //unsavedPhoto.push({ "name": name, "dk": dateTime, "comment": '', "blobUrl": photoUrl, "base64Img": base64Photo });
                                                checkList.photo.push({ "name": name, "dk": dateTime, "comment": '', "blobUrl": photoUrl, "base64Img": base64Photo });

                                                //let value = JSON.stringify(unsavedPhoto);
                                                let value = JSON.stringify(checkList);

                                                //localStorage.setItem("unsavedPhotoCheckList", value);
                                                localStorage.setItem("checkList", value);
                                                paintPhotoCheckList("danger");
                                            });
                                        });
                                        const input = document.getElementById('cameraFileInput');
                                        input.focus();
                                        input.click();
                                    },
                                }, "Фото"),
                            ]),
                            m("input[id='cameraFileInput'][type='file'][accept='image/*'][capture='environment']")
                        ]),
                        m("tr", [
                            m("td[colspan='12']",[
                                m("div[id='pictureConteiner'][style='width: 100%; height: auto; margin-bottom: 8px;']", [
                                    ctrl.checkList.photo.map(function (elem) {
                                        return m("div", {
                                            id: elem.name,
                                            style: 'display: flex; flex-direction: column; align-items: center; margin-top: 7px; outline: 1px solid #000;'
                                        }, [
                                            m("div", {
                                                className: "row bg-danger",
                                                style: "padding:6px;padding-right: 11px;z-index:1; width: 100%; min-height: 32px;"
                                            }, [
                                                ctrl.checkList.sign ? [] : m("span", {
                                                    className: "pull-right classReadOnly",
                                                    style: "cursor: pointer;",
                                                    innerHTML: "<i class='glyphicon glyphicon-remove'>&nbsp;Удалить",
                                                    onclick: function () {
                                                        ModalContainerWarningRemovePhotoCheckList.open("Вы действительно хотите удалить фото?", false, elem.name, false);
                                                    }
                                                })
                                            ]),
                                            m("img", {
                                                src: elem.base64Img, //elem.blobUrl,
                                                name: elem.name,
                                                className: "col-xs-12 col-sm-6 col-md-4 col-xl img-thumbnail",
                                                onerror: function () {
                                                    removeElementIndexedDB(elem.name);
                                                }
                                            })
                                        ])
                                    }),
                                ]),
                                ModalContainerWarningRemovePhotoCheckList.init()
                            ]),
                        ]),
                        m("tr", [
                            m("td.col-xs-4[colspan='4'][style='text-align: right']", ["Примечание"]),
                            m("td.col-xs-8[colspan='8'][style='text-align: right; padding:2px 7px;']", [
                                m("textarea.form-control[rows='3'][maxlength='600'][id='commentCheckList']", {
                                    disabled: ctrl.checkList.sign ? "disabled" : "",
                                    /*onblur: function () {
                                        loader.show();
                                        checkList = { "comment": this.value.trim() };
                                        m.request({
                                            method: 'PUT',
                                            url: '/api/task/' + m.route.param('taskId') + '/setAuditComment',
                                            data: checkList
                                        }).then(function (response) {
                                            loader.hide();
                                        }, function () {
                                            loader.hide();
                                        });
                                    }*/
                                }, ctrl.checkList.comment)
                            ]),
                        ]),
                        m("tr", [
                            m("td.col-xs-8[colspan='8'][style='text-align: right']", ["Осмотр ВС согласно установленного маршрута выполнен"]),
                            m("td.col-xs-4[colspan='4'][style='text-align: right; padding:2px 7px;'][id='tdButtonSign']", [
                                m("button.btn.btn-danger.btn-lg[style='width:100%'][id='signAudit']", {
                                    disabled: ctrl.checkList.sign ? "disabled" : "",
                                    //class: showSignatureButton ? '' : 'hidden',
                                    onclick: function () {
                                        let check = checkingFilling();
                                        if(check) {
                                            ModalContainerCHL.open("Подпись чек-листа");
                                            document.getElementById("yesBtnModalSignCheckList").addEventListener("click", function () {
                                                var canvas = document.getElementById("canvasSignCheckList");
                                                if(isCanvasBlank(canvas) == false)
                                                    saveCheckListDB();

                                                ModalContainerCHL.close();
                                            });
                                        }
                                        else {
                                            modalContainerWarningCheckList.open("Чек-лист не заполнен");
                                            //alert("Чек-лист не заполнен");
                                        }
                                    }
                                }, "Подписать")
                            ]),
                            ModalContainerCHL.init()
                        ])
                    ]),
                ]
        ])
    }
};
